
import { interpolate, printf, toFail } from "../../fable_modules/fable-library-js.5.13.0/String.js";
import { Constants_maxTruthTableBusWidth } from "../TruthTableTypes.js";
import { item } from "../../fable_modules/fable-library-js.5.13.0/Array.js";
import { convertFastDataToInt, convertIntToFastData, convertFastDataToBigint, convertBigintToFastData } from "../NumberHelpers.js";
import { FData__get_toFastData, FData__get_Width, FData__get_toExp, FData } from "../SimTypes.js";
import { getAlgExpWidth, foldAppends, zeroLiteral, bigIntMask, AlgebraNotImplemented, SimulationError, SimulationErrorType, BinaryOp, ComparisonOp, getBits, FastData, FastBits, FastAlgExp, UnaryOp } from "../SimGraphTypes.js";
import { op_BitwiseOr, fromZero, op_BitwiseAnd, fromOne, op_LeftShift, op_Subtraction, op_RightShift, toUInt32_unchecked, fromUInt32, op_Addition, toUInt64_unchecked, toUInt32, equals } from "../../fable_modules/fable-library-js.5.13.0/BigInt.js";
import { zip, iterateIndexed, fold, sumBy, forAll, cons, append, ofArray, replicate, empty, singleton, reduce, exists, map } from "../../fable_modules/fable-library-js.5.13.0/List.js";
import { toList } from "../../fable_modules/fable-library-js.5.13.0/Seq.js";
import { rangeDouble } from "../../fable_modules/fable-library-js.5.13.0/Range.js";
import { Exception, uncurry2 } from "../../fable_modules/fable-library-js.5.13.0/Util.js";
import { getRamStore, writeRamFData, readRamFData, ramStoreOf, getRamState, readMemoryFData } from "./EvalKernel.js";
import { reset } from "../RamStore.js";

/**
 * Version of fastReduce which operates on the IOArray.FDataStep arrays,
 * and simulates using posibly algebraic data.
 * Given the input port values for a component comp, work out its output in the same clock cycle.
 * Used by TruthTable simulations, which use FData type that includes algebraic data.
 * Because TruthTable simulations are only combinational the match statement is much simpler than normal EvalReference.
 * Clocked operations need not be implemented.
 */
export function fastReduceFData(maxArraySize, numStep, isClockedReduction, comp) {
    let fd_, fd_16, matchValue_1, _arg_17, list_2, gateType_2, gateType_3, gateType_4, gateType_5, fd__1, fd_34, matchValue_10, fd__2, fd_36, matchValue_11, fd__3, fd_38, matchValue_12, fd__4, fd_40, matchValue_13, fd__7, fd_62, matchValue_37, matchValue_69, matchValue_70, matchValue_72, matchValue_79, matchValue_80, matchValue_87, matchValue_88, matchValue_93, a_10, matchValue_94, matchValue_100, amt_1, fd__10, fd_167, matchValue_114, fd__12, fd_172, matchValue_119, fd__13, fd_181, matchValue_127, fd__14, fd_188, matchValue_134, fd__15, fd_189, matchValue_135, matchValue_138, matchValue_136, fd__16, fd_192, matchValue_139, fd__17, fd_193, matchValue_140, fd__18, fd_199, matchValue_146, matchValue_149, matchValue_147, fd__19, fd_204, matchValue_151, matchValue_154, matchValue_152, matchValue_159, matchValue_157, matchValue_170;
    const componentType = comp.FType;
    const simStep = (numStep % maxArraySize) | 0;
    const simStepOld = ((simStep === 0) ? (maxArraySize - 1) : (simStep - 1)) | 0;
    const tooWideForTable = (bits) => toFail(printf("What? %s was reduced with a %d-bit value, and a truth table carries at most %d bits - buildFastSimulationFData should have refused this circuit"))(comp.FullName)(bits.Width)(Constants_maxTruthTableBusWidth);
    let matchResult, cVal, width_3, numberOfBits, numberOfBits_1;
    switch (componentType.tag) {
        case 44:
        case 45:
        case 43: {
            matchResult = 0;
            break;
        }
        case 48: {
            matchResult = 1;
            break;
        }
        case 0: {
            matchResult = 2;
            break;
        }
        case 1: {
            matchResult = 4;
            break;
        }
        case 2: {
            matchResult = 5;
            break;
        }
        case 3: {
            matchResult = 6;
            break;
        }
        case 4: {
            matchResult = 7;
            break;
        }
        case 8: {
            matchResult = 8;
            break;
        }
        case 6: {
            matchResult = 9;
            break;
        }
        case 47: {
            matchResult = 10;
            break;
        }
        case 5: {
            matchResult = 11;
            break;
        }
        case 10: {
            matchResult = 12;
            break;
        }
        case 11: {
            matchResult = 13;
            break;
        }
        case 12: {
            matchResult = 14;
            break;
        }
        case 13: {
            matchResult = 15;
            break;
        }
        case 14: {
            matchResult = 16;
            break;
        }
        case 15: {
            matchResult = 17;
            break;
        }
        case 16: {
            matchResult = 18;
            break;
        }
        case 21: {
            matchResult = 21;
            break;
        }
        case 24: {
            matchResult = 22;
            break;
        }
        case 22: {
            matchResult = 23;
            break;
        }
        case 23: {
            matchResult = 24;
            break;
        }
        case 25: {
            matchResult = 25;
            break;
        }
        case 46: {
            matchResult = 26;
            break;
        }
        case 26: {
            matchResult = 27;
            break;
        }
        case 27: {
            matchResult = 28;
            break;
        }
        case 29: {
            matchResult = 29;
            break;
        }
        case 54: {
            matchResult = 30;
            break;
        }
        case 55: {
            matchResult = 31;
            break;
        }
        case 28: {
            matchResult = 32;
            break;
        }
        case 30: {
            matchResult = 33;
            break;
        }
        case 31: {
            matchResult = 34;
            break;
        }
        case 32: {
            matchResult = 35;
            break;
        }
        case 33: {
            matchResult = 36;
            break;
        }
        case 34: {
            matchResult = 37;
            break;
        }
        case 35: {
            matchResult = 38;
            break;
        }
        case 37: {
            matchResult = 39;
            break;
        }
        case 36: {
            matchResult = 40;
            break;
        }
        case 38: {
            matchResult = 41;
            break;
        }
        case 39: {
            matchResult = 42;
            break;
        }
        case 40: {
            matchResult = 43;
            break;
        }
        case 41: {
            matchResult = 44;
            break;
        }
        case 42: {
            matchResult = 45;
            break;
        }
        case 7: {
            matchResult = 3;
            cVal = componentType.fields[1];
            width_3 = componentType.fields[0];
            break;
        }
        case 49: {
            matchResult = 3;
            cVal = componentType.fields[1];
            width_3 = componentType.fields[0];
            break;
        }
        case 17: {
            matchResult = 19;
            numberOfBits = componentType.fields[0];
            break;
        }
        case 19: {
            matchResult = 19;
            numberOfBits = componentType.fields[0];
            break;
        }
        case 18: {
            matchResult = 20;
            numberOfBits_1 = componentType.fields[0];
            break;
        }
        case 20: {
            matchResult = 20;
            numberOfBits_1 = componentType.fields[0];
            break;
        }
        default:
            matchResult = 46;
    }
    switch (matchResult) {
        case 0: {
            toFail(printf("What? Legacy RAM component types should never occur"));
            break;
        }
        case 1: {
            toFail(printf("Legacy Input component types should never occur"));
            break;
        }
        case 2: {
            if (comp.Active) {
                const bits_3 = item(simStep, item(0, comp.InputLinks).FDataStep);
                item(0, comp.Outputs).FDataStep[simStep] = bits_3;
            }
            break;
        }
        case 3: {
            const fd_7 = new FData(/* Data */ 0, [convertBigintToFastData(width_3, cVal)]);
            item(0, comp.Outputs).FDataStep[simStep] = fd_7;
            break;
        }
        case 4: {
            const bits_5 = item(simStep, item(0, comp.InputLinks).FDataStep);
            item(0, comp.Outputs).FDataStep[simStep] = bits_5;
            break;
        }
        case 5: {
            const bits_7 = item(simStep, item(0, comp.InputLinks).FDataStep);
            item(0, comp.Outputs).FDataStep[simStep] = bits_7;
            break;
        }
        case 6: {
            const fd_13 = item(simStep, item(0, comp.InputLinks).FDataStep);
            item(0, comp.Outputs).FDataStep[simStep] = fd_13;
            break;
        }
        case 7: {
            break;
        }
        case 8: {
            const matchValue = item(simStep, item(0, comp.InputLinks).FDataStep);
            if (matchValue.tag === 1) {
                item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Alg */ 1, [new FastAlgExp(/* UnaryExp */ 2, [UnaryOp.NotOp, matchValue.fields[0]])]));
            }
            else {
                const fd_17 = (((((fd_ = item(simStep, item(0, comp.InputLinks).FDataStep), (fd_.tag === 0) ? ((fd_16 = fd_.fields[0], (matchValue_1 = fd_16.Dat, (matchValue_1.tag === 1) ? toFail(`Can't extract ${interpolate("%d%P()", [1])} bit from BigWord data ${fd_16.Dat} of width ${fd_16.Width}`) : matchValue_1.fields[0]))) : toFail(printf("Can\'t extract data from Algebra")))) ^ 1) >>> 0) === 0) ? (new FData(/* Data */ 0, [new FastData(new FastBits(/* Word */ 0, [0]), 1)])) : (new FData(/* Data */ 0, [new FastData(new FastBits(/* Word */ 0, [1]), 1)]));
                item(0, comp.Outputs).FDataStep[simStep] = fd_17;
            }
            break;
        }
        case 9: {
            const width_8 = componentType.fields[0] | 0;
            const lsb_1 = componentType.fields[1] | 0;
            const matchValue_2 = item(simStep, item(0, comp.InputLinks).FDataStep);
            if (matchValue_2.tag === 1) {
                const newExp = new FastAlgExp(/* UnaryExp */ 2, [new UnaryOp(/* BitRangeOp */ 2, [lsb_1, (lsb_1 + width_8) - 1]), matchValue_2.fields[0]]);
                item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Alg */ 1, [newExp]));
            }
            else {
                const outBits = getBits((lsb_1 + width_8) - 1, lsb_1, matchValue_2.fields[0]);
                item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Data */ 0, [outBits]));
            }
            break;
        }
        case 10: {
            const compareVal = componentType.fields[1];
            const matchValue_3 = item(simStep, item(0, comp.InputLinks).FDataStep);
            if (matchValue_3.tag === 1) {
                item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Alg */ 1, [new FastAlgExp(/* ComparisonExp */ 4, [matchValue_3.fields[0], ComparisonOp.Equals, compareVal])]));
            }
            else {
                const fd_23 = ((equals(convertFastDataToBigint(matchValue_3.fields[0]), compareVal) ? 1 : 0) === 0) ? (new FData(/* Data */ 0, [new FastData(new FastBits(/* Word */ 0, [0]), 1)])) : (new FData(/* Data */ 0, [new FastData(new FastBits(/* Word */ 0, [1]), 1)]));
                item(0, comp.Outputs).FDataStep[simStep] = fd_23;
            }
            break;
        }
        case 11: {
            const compareVal_1 = componentType.fields[1];
            const matchValue_4 = item(simStep, item(0, comp.InputLinks).FDataStep);
            if (matchValue_4.tag === 1) {
                item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Alg */ 1, [new FastAlgExp(/* ComparisonExp */ 4, [matchValue_4.fields[0], ComparisonOp.Equals, compareVal_1])]));
            }
            else {
                const fd_26 = ((equals(convertFastDataToBigint(matchValue_4.fields[0]), compareVal_1) ? 1 : 0) === 0) ? (new FData(/* Data */ 0, [new FastData(new FastBits(/* Word */ 0, [0]), 1)])) : (new FData(/* Data */ 0, [new FastData(new FastBits(/* Word */ 0, [1]), 1)]));
                item(0, comp.Outputs).FDataStep[simStep] = fd_26;
            }
            break;
        }
        case 12: {
            const gateType_1 = componentType.fields[0];
            const inputs = map((i_9) => item(simStep, item(i_9, comp.InputLinks).FDataStep), toList(rangeDouble(0, 1, componentType.fields[1] - 1)));
            if (exists((inp) => {
                if (inp.tag === 0) {
                    return false;
                }
                else {
                    return true;
                }
            }, inputs)) {
                const fd_29 = new FData(/* Alg */ 1, [(_arg_17 = ((list_2 = map(FData__get_toExp, inputs), reduce(uncurry2((gateType_2 = gateType_1, (gateType_2 === "nand") ? ((exp_11) => ((exp_1_1) => (new FastAlgExp(/* BinaryExp */ 3, [exp_11, BinaryOp.BitAndOp, exp_1_1])))) : ((gateType_2 === "or") ? ((exp_2_1) => ((exp_3_1) => (new FastAlgExp(/* BinaryExp */ 3, [exp_2_1, BinaryOp.BitOrOp, exp_3_1])))) : ((gateType_2 === "nor") ? ((exp_2_1) => ((exp_3_1) => (new FastAlgExp(/* BinaryExp */ 3, [exp_2_1, BinaryOp.BitOrOp, exp_3_1])))) : ((gateType_2 === "xor") ? ((exp_4_1) => ((exp_5_1) => (new FastAlgExp(/* BinaryExp */ 3, [exp_4_1, BinaryOp.BitXorOp, exp_5_1])))) : ((gateType_2 === "xnor") ? ((exp_4_1) => ((exp_5_1) => (new FastAlgExp(/* BinaryExp */ 3, [exp_4_1, BinaryOp.BitXorOp, exp_5_1])))) : ((exp_11) => ((exp_1_1) => (new FastAlgExp(/* BinaryExp */ 3, [exp_11, BinaryOp.BitAndOp, exp_1_1])))))))))), list_2))), ((gateType_3 = gateType_1, (gateType_3 === "nor") ? true : ((gateType_3 === "xnor") ? true : ((gateType_3 === "and") ? false : ((gateType_3 === "or") ? false : (!(gateType_3 === "xor"))))))) ? (new FastAlgExp(/* UnaryExp */ 2, [UnaryOp.NotOp, _arg_17])) : _arg_17)]);
                item(0, comp.Outputs).FDataStep[simStep] = fd_29;
            }
            else {
                let fd_30;
                let _arg_20;
                const list_4 = map((_arg_19) => {
                    if (_arg_19.tag === 1) {
                        throw new Exception("Can\'t encounter algebraic expression here");
                    }
                    else {
                        const this$_18 = _arg_19.fields[0];
                        const matchValue_5 = this$_18.Dat;
                        if (matchValue_5.tag === 1) {
                            if (this$_18.Width <= 32) {
                                return toUInt32(matchValue_5.fields[0]) >>> 0;
                            }
                            else {
                                return toFail(printf("GetQint32 Can\'t turn Alg into a uint32"));
                            }
                        }
                        else {
                            return matchValue_5.fields[0];
                        }
                    }
                }, inputs);
                _arg_20 = reduce(uncurry2((gateType_4 = gateType_1, (gateType_4 === "nand") ? ((bit_7) => ((bit_1_1) => ((bit_7 & bit_1_1) >>> 0))) : ((gateType_4 === "or") ? ((bit_2_1) => ((bit_3_1) => ((bit_2_1 | bit_3_1) >>> 0))) : ((gateType_4 === "nor") ? ((bit_2_1) => ((bit_3_1) => ((bit_2_1 | bit_3_1) >>> 0))) : ((gateType_4 === "xor") ? ((bit_4_1) => ((bit_5_1) => ((bit_4_1 ^ bit_5_1) >>> 0))) : ((gateType_4 === "xnor") ? ((bit_4_1) => ((bit_5_1) => ((bit_4_1 ^ bit_5_1) >>> 0))) : ((bit_7) => ((bit_1_1) => ((bit_7 & bit_1_1) >>> 0))))))))), list_4);
                fd_30 = (((gateType_5 = gateType_1, (gateType_5 === "nor") ? true : ((gateType_5 === "xnor") ? true : ((gateType_5 === "and") ? false : ((gateType_5 === "or") ? false : (!(gateType_5 === "xor"))))))) ? ((_arg_20 === 1) ? (new FData(/* Data */ 0, [new FastData(new FastBits(/* Word */ 0, [0]), 1)])) : (new FData(/* Data */ 0, [new FastData(new FastBits(/* Word */ 0, [1]), 1)]))) : (new FData(/* Data */ 0, [new FastData(new FastBits(/* Word */ 0, [_arg_20]), 1)])));
                item(0, comp.Outputs).FDataStep[simStep] = fd_30;
            }
            break;
        }
        case 13: {
            const matchValue_6 = item(simStep, item(0, comp.InputLinks).FDataStep);
            const matchValue_7 = item(simStep, item(1, comp.InputLinks).FDataStep);
            const matchValue_8 = item(simStep, item(2, comp.InputLinks).FDataStep);
            let matchResult_1, bitSelect, exp1_3, exp2_3, bitSelect_1, bits_13, exp_15, bitSelect_2, bits_14, exp_16, bitSelect_3, bits0, bits1;
            if (matchValue_6.tag === 0) {
                if (matchValue_7.tag === 0) {
                    if (matchValue_8.tag === 1) {
                        matchResult_1 = 4;
                    }
                    else {
                        matchResult_1 = 3;
                        bitSelect_3 = matchValue_8.fields[0];
                        bits0 = matchValue_6.fields[0];
                        bits1 = matchValue_7.fields[0];
                    }
                }
                else if (matchValue_8.tag === 1) {
                    matchResult_1 = 4;
                }
                else {
                    matchResult_1 = 2;
                    bitSelect_2 = matchValue_8.fields[0];
                    bits_14 = matchValue_6.fields[0];
                    exp_16 = matchValue_7.fields[0];
                }
            }
            else if (matchValue_7.tag === 0) {
                if (matchValue_8.tag === 1) {
                    matchResult_1 = 4;
                }
                else {
                    matchResult_1 = 1;
                    bitSelect_1 = matchValue_8.fields[0];
                    bits_13 = matchValue_7.fields[0];
                    exp_15 = matchValue_6.fields[0];
                }
            }
            else if (matchValue_8.tag === 1) {
                matchResult_1 = 4;
            }
            else {
                matchResult_1 = 0;
                bitSelect = matchValue_8.fields[0];
                exp1_3 = matchValue_6.fields[0];
                exp2_3 = matchValue_7.fields[0];
            }
            switch (matchResult_1) {
                case 0: {
                    const fd_35 = (((fd__1 = (new FData(/* Data */ 0, [bitSelect])), (fd__1.tag === 0) ? ((fd_34 = fd__1.fields[0], (matchValue_10 = fd_34.Dat, (matchValue_10.tag === 1) ? toFail(`Can't extract ${interpolate("%d%P()", [1])} bit from BigWord data ${fd_34.Dat} of width ${fd_34.Width}`) : matchValue_10.fields[0]))) : toFail(printf("Can\'t extract data from Algebra")))) === 0) ? (new FData(/* Alg */ 1, [exp1_3])) : (new FData(/* Alg */ 1, [exp2_3]));
                    item(0, comp.Outputs).FDataStep[simStep] = fd_35;
                    break;
                }
                case 1: {
                    const fd_37 = (((fd__2 = (new FData(/* Data */ 0, [bitSelect_1])), (fd__2.tag === 0) ? ((fd_36 = fd__2.fields[0], (matchValue_11 = fd_36.Dat, (matchValue_11.tag === 1) ? toFail(`Can't extract ${interpolate("%d%P()", [1])} bit from BigWord data ${fd_36.Dat} of width ${fd_36.Width}`) : matchValue_11.fields[0]))) : toFail(printf("Can\'t extract data from Algebra")))) === 0) ? (new FData(/* Alg */ 1, [exp_15])) : (new FData(/* Data */ 0, [bits_13]));
                    item(0, comp.Outputs).FDataStep[simStep] = fd_37;
                    break;
                }
                case 2: {
                    const fd_39 = (((fd__3 = (new FData(/* Data */ 0, [bitSelect_2])), (fd__3.tag === 0) ? ((fd_38 = fd__3.fields[0], (matchValue_12 = fd_38.Dat, (matchValue_12.tag === 1) ? toFail(`Can't extract ${interpolate("%d%P()", [1])} bit from BigWord data ${fd_38.Dat} of width ${fd_38.Width}`) : matchValue_12.fields[0]))) : toFail(printf("Can\'t extract data from Algebra")))) === 0) ? (new FData(/* Data */ 0, [bits_14])) : (new FData(/* Alg */ 1, [exp_16]));
                    item(0, comp.Outputs).FDataStep[simStep] = fd_39;
                    break;
                }
                case 3: {
                    const out_3 = (((fd__4 = (new FData(/* Data */ 0, [bitSelect_3])), (fd__4.tag === 0) ? ((fd_40 = fd__4.fields[0], (matchValue_13 = fd_40.Dat, (matchValue_13.tag === 1) ? toFail(`Can't extract ${interpolate("%d%P()", [1])} bit from BigWord data ${fd_40.Dat} of width ${fd_40.Width}`) : matchValue_13.fields[0]))) : toFail(printf("Can\'t extract data from Algebra")))) === 0) ? bits0 : bits1;
                    item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Data */ 0, [out_3]));
                    break;
                }
                case 4: {
                    throw new AlgebraNotImplemented(new SimulationError(new SimulationErrorType(/* AlgInpNotAllowed */ 15, ["The chosen set of Algebraic inputs results in algebra being passed to the\r\n                    SEL port of a Mux2. Only values can be passed to this port."]), comp.FullName, singleton(comp.cId), empty()));
                    break;
                }
            }
            break;
        }
        case 14: {
            const matchValue_14 = item(simStep, item(0, comp.InputLinks).FDataStep);
            const matchValue_15 = item(simStep, item(1, comp.InputLinks).FDataStep);
            const matchValue_16 = item(simStep, item(2, comp.InputLinks).FDataStep);
            const matchValue_17 = item(simStep, item(3, comp.InputLinks).FDataStep);
            const matchValue_18 = item(simStep, item(4, comp.InputLinks).FDataStep);
            if (matchValue_18.tag === 1) {
                throw new AlgebraNotImplemented(new SimulationError(new SimulationErrorType(/* AlgInpNotAllowed */ 15, ["The chosen set of Algebraic inputs results in algebra being passed to the\r\n                    SEL port of a Mux4. Only values can be passed to this port."]), comp.FullName, singleton(comp.cId), empty()));
            }
            else {
                let fd_48;
                let matchValue_21;
                const fd__5 = new FData(/* Data */ 0, [matchValue_18.fields[0]]);
                if (fd__5.tag === 0) {
                    const fd_47 = fd__5.fields[0];
                    const matchValue_20 = fd_47.Dat;
                    matchValue_21 = ((matchValue_20.tag === 1) ? toFail(`Can't extract ${interpolate("%d%P()", [2])} bit from BigWord data ${fd_47.Dat} of width ${fd_47.Width}`) : matchValue_20.fields[0]);
                }
                else {
                    matchValue_21 = toFail(printf("Can\'t extract data from Algebra"));
                }
                fd_48 = ((matchValue_21 === 0) ? matchValue_14 : ((matchValue_21 === 1) ? matchValue_15 : ((matchValue_21 === 2) ? matchValue_16 : ((matchValue_21 === 3) ? matchValue_17 : toFail(printf("Cannot happen"))))));
                item(0, comp.Outputs).FDataStep[simStep] = fd_48;
            }
            break;
        }
        case 15: {
            const matchValue_22 = item(simStep, item(0, comp.InputLinks).FDataStep);
            const matchValue_23 = item(simStep, item(1, comp.InputLinks).FDataStep);
            const matchValue_24 = item(simStep, item(2, comp.InputLinks).FDataStep);
            const matchValue_25 = item(simStep, item(3, comp.InputLinks).FDataStep);
            const matchValue_26 = item(simStep, item(4, comp.InputLinks).FDataStep);
            const matchValue_27 = item(simStep, item(5, comp.InputLinks).FDataStep);
            const matchValue_28 = item(simStep, item(6, comp.InputLinks).FDataStep);
            const matchValue_29 = item(simStep, item(7, comp.InputLinks).FDataStep);
            const matchValue_30 = item(simStep, item(8, comp.InputLinks).FDataStep);
            if (matchValue_30.tag === 1) {
                throw new AlgebraNotImplemented(new SimulationError(new SimulationErrorType(/* AlgInpNotAllowed */ 15, ["The chosen set of Algebraic inputs results in algebra being passed to the\r\n                    SEL port of a Mux8. Only values can be passed to this port."]), comp.FullName, singleton(comp.cId), empty()));
            }
            else {
                let fd_59;
                let matchValue_33;
                const fd__6 = new FData(/* Data */ 0, [matchValue_30.fields[0]]);
                if (fd__6.tag === 0) {
                    const fd_58 = fd__6.fields[0];
                    const matchValue_32 = fd_58.Dat;
                    matchValue_33 = ((matchValue_32.tag === 1) ? toFail(`Can't extract ${interpolate("%d%P()", [3])} bit from BigWord data ${fd_58.Dat} of width ${fd_58.Width}`) : matchValue_32.fields[0]);
                }
                else {
                    matchValue_33 = toFail(printf("Can\'t extract data from Algebra"));
                }
                fd_59 = ((matchValue_33 === 0) ? matchValue_22 : ((matchValue_33 === 1) ? matchValue_23 : ((matchValue_33 === 2) ? matchValue_24 : ((matchValue_33 === 3) ? matchValue_25 : ((matchValue_33 === 4) ? matchValue_26 : ((matchValue_33 === 5) ? matchValue_27 : ((matchValue_33 === 6) ? matchValue_28 : ((matchValue_33 === 7) ? matchValue_29 : toFail(printf("Cannot happen"))))))))));
                item(0, comp.Outputs).FDataStep[simStep] = fd_59;
            }
            break;
        }
        case 16: {
            const matchValue_34 = item(simStep, item(0, comp.InputLinks).FDataStep);
            const matchValue_35 = item(simStep, item(1, comp.InputLinks).FDataStep);
            if (matchValue_35.tag === 1) {
                throw new AlgebraNotImplemented(new SimulationError(new SimulationErrorType(/* AlgInpNotAllowed */ 15, ["The chosen set of Algebraic inputs results in algebra being passed to the\r\n                    SEL port of a Demux2. Only values can be passed to this port."]), comp.FullName, singleton(comp.cId), empty()));
            }
            else {
                const fdIn = matchValue_34;
                const zeros = new FData(/* Data */ 0, [convertIntToFastData(FData__get_Width(fdIn), 0)]);
                const patternInput = (((fd__7 = (new FData(/* Data */ 0, [matchValue_35.fields[0]])), (fd__7.tag === 0) ? ((fd_62 = fd__7.fields[0], (matchValue_37 = fd_62.Dat, (matchValue_37.tag === 1) ? toFail(`Can't extract ${interpolate("%d%P()", [1])} bit from BigWord data ${fd_62.Dat} of width ${fd_62.Width}`) : matchValue_37.fields[0]))) : toFail(printf("Can\'t extract data from Algebra")))) === 0) ? [fdIn, zeros] : [zeros, fdIn];
                FData__get_Width(fdIn);
                item(0, comp.Outputs).FDataStep[simStep] = patternInput[0];
                item(1, comp.Outputs).FDataStep[simStep] = patternInput[1];
            }
            break;
        }
        case 17: {
            const matchValue_38 = item(simStep, item(0, comp.InputLinks).FDataStep);
            const matchValue_39 = item(simStep, item(1, comp.InputLinks).FDataStep);
            if (matchValue_39.tag === 1) {
                throw new AlgebraNotImplemented(new SimulationError(new SimulationErrorType(/* AlgInpNotAllowed */ 15, ["The chosen set of Algebraic inputs results in algebra being passed to the\r\n                    SEL port of a Demux4. Only values can be passed to this port."]), comp.FullName, singleton(comp.cId), empty()));
            }
            else {
                const fdIn_1 = matchValue_38;
                const zeros_1 = new FData(/* Data */ 0, [convertIntToFastData(FData__get_Width(fdIn_1), 0)]);
                let patternInput_1;
                let matchValue_42;
                const fd__8 = new FData(/* Data */ 0, [matchValue_39.fields[0]]);
                if (fd__8.tag === 0) {
                    const fd_67 = fd__8.fields[0];
                    const matchValue_41 = fd_67.Dat;
                    matchValue_42 = ((matchValue_41.tag === 1) ? toFail(`Can't extract ${interpolate("%d%P()", [2])} bit from BigWord data ${fd_67.Dat} of width ${fd_67.Width}`) : matchValue_41.fields[0]);
                }
                else {
                    matchValue_42 = toFail(printf("Can\'t extract data from Algebra"));
                }
                patternInput_1 = ((matchValue_42 === 0) ? [fdIn_1, zeros_1, zeros_1, zeros_1] : ((matchValue_42 === 1) ? [zeros_1, fdIn_1, zeros_1, zeros_1] : ((matchValue_42 === 2) ? [zeros_1, zeros_1, fdIn_1, zeros_1] : ((matchValue_42 === 3) ? [zeros_1, zeros_1, zeros_1, fdIn_1] : toFail(printf("Cannot happen"))))));
                FData__get_Width(fdIn_1);
                item(0, comp.Outputs).FDataStep[simStep] = patternInput_1[0];
                item(1, comp.Outputs).FDataStep[simStep] = patternInput_1[1];
                item(2, comp.Outputs).FDataStep[simStep] = patternInput_1[2];
                item(3, comp.Outputs).FDataStep[simStep] = patternInput_1[3];
            }
            break;
        }
        case 18: {
            const matchValue_43 = item(simStep, item(0, comp.InputLinks).FDataStep);
            const matchValue_44 = item(simStep, item(1, comp.InputLinks).FDataStep);
            if (matchValue_44.tag === 1) {
                throw new AlgebraNotImplemented(new SimulationError(new SimulationErrorType(/* AlgInpNotAllowed */ 15, ["The chosen set of Algebraic inputs results in algebra being passed to the\r\n                    SEL port of a Demux8. Only values can be passed to this port."]), comp.FullName, singleton(comp.cId), empty()));
            }
            else {
                const fdIn_2 = matchValue_43;
                const zeros_2 = new FData(/* Data */ 0, [convertIntToFastData(FData__get_Width(fdIn_2), 0)]);
                let patternInput_2;
                let matchValue_47;
                const fd__9 = new FData(/* Data */ 0, [matchValue_44.fields[0]]);
                if (fd__9.tag === 0) {
                    const fd_74 = fd__9.fields[0];
                    const matchValue_46 = fd_74.Dat;
                    matchValue_47 = ((matchValue_46.tag === 1) ? toFail(`Can't extract ${interpolate("%d%P()", [3])} bit from BigWord data ${fd_74.Dat} of width ${fd_74.Width}`) : matchValue_46.fields[0]);
                }
                else {
                    matchValue_47 = toFail(printf("Can\'t extract data from Algebra"));
                }
                patternInput_2 = ((matchValue_47 === 0) ? [fdIn_2, zeros_2, zeros_2, zeros_2, zeros_2, zeros_2, zeros_2, zeros_2] : ((matchValue_47 === 1) ? [zeros_2, fdIn_2, zeros_2, zeros_2, zeros_2, zeros_2, zeros_2, zeros_2] : ((matchValue_47 === 2) ? [zeros_2, zeros_2, fdIn_2, zeros_2, zeros_2, zeros_2, zeros_2, zeros_2] : ((matchValue_47 === 3) ? [zeros_2, zeros_2, zeros_2, fdIn_2, zeros_2, zeros_2, zeros_2, zeros_2] : ((matchValue_47 === 4) ? [zeros_2, zeros_2, zeros_2, zeros_2, fdIn_2, zeros_2, zeros_2, zeros_2] : ((matchValue_47 === 5) ? [zeros_2, zeros_2, zeros_2, zeros_2, zeros_2, fdIn_2, zeros_2, zeros_2] : ((matchValue_47 === 6) ? [zeros_2, zeros_2, zeros_2, zeros_2, zeros_2, zeros_2, fdIn_2, zeros_2] : ((matchValue_47 === 7) ? [zeros_2, zeros_2, zeros_2, zeros_2, zeros_2, zeros_2, zeros_2, fdIn_2] : toFail(printf("Cannot happen"))))))))));
                FData__get_Width(fdIn_2);
                item(0, comp.Outputs).FDataStep[simStep] = patternInput_2[0];
                item(1, comp.Outputs).FDataStep[simStep] = patternInput_2[1];
                item(2, comp.Outputs).FDataStep[simStep] = patternInput_2[2];
                item(3, comp.Outputs).FDataStep[simStep] = patternInput_2[3];
                item(4, comp.Outputs).FDataStep[simStep] = patternInput_2[4];
                item(5, comp.Outputs).FDataStep[simStep] = patternInput_2[5];
                item(6, comp.Outputs).FDataStep[simStep] = patternInput_2[6];
                item(7, comp.Outputs).FDataStep[simStep] = patternInput_2[7];
            }
            break;
        }
        case 19: {
            const matchValue_48 = item(simStep, item(0, comp.InputLinks).FDataStep);
            const matchValue_49 = item(simStep, item(1, comp.InputLinks).FDataStep);
            const matchValue_50 = item(simStep, item(2, comp.InputLinks).FDataStep);
            let matchResult_2, aIn, bIn, cin, aIn_1, bIn_1, cin_2;
            if (matchValue_48.tag === 0) {
                if (matchValue_49.tag === 0) {
                    if (matchValue_50.tag === 0) {
                        matchResult_2 = 0;
                        aIn = matchValue_49.fields[0];
                        bIn = matchValue_50.fields[0];
                        cin = matchValue_48.fields[0];
                    }
                    else {
                        matchResult_2 = 1;
                        aIn_1 = matchValue_49;
                        bIn_1 = matchValue_50;
                        cin_2 = matchValue_48;
                    }
                }
                else {
                    matchResult_2 = 1;
                    aIn_1 = matchValue_49;
                    bIn_1 = matchValue_50;
                    cin_2 = matchValue_48;
                }
            }
            else {
                matchResult_2 = 1;
                aIn_1 = matchValue_49;
                bIn_1 = matchValue_50;
                cin_2 = matchValue_48;
            }
            switch (matchResult_2) {
                case 0: {
                    let patternInput_3;
                    const cin_1 = convertFastDataToInt(cin);
                    const w_5 = aIn.Width | 0;
                    const matchValue_52 = aIn.Dat;
                    const matchValue_53 = bIn.Dat;
                    let matchResult_3, a, b, a_1, b_1;
                    if (matchValue_52.tag === 0) {
                        if (matchValue_53.tag === 0) {
                            matchResult_3 = 0;
                            a = matchValue_52.fields[0];
                            b = matchValue_53.fields[0];
                        }
                        else {
                            matchResult_3 = 1;
                            a_1 = matchValue_52;
                            b_1 = matchValue_53;
                        }
                    }
                    else {
                        matchResult_3 = 1;
                        a_1 = matchValue_52;
                        b_1 = matchValue_53;
                    }
                    switch (matchResult_3) {
                        case 0: {
                            const mask = ((1 << w_5) >>> 0) - 1;
                            if (w_5 === 32) {
                                const sumInt = toUInt64_unchecked(op_Addition(toUInt64_unchecked(op_Addition(toUInt64_unchecked(fromUInt32(a)), toUInt64_unchecked(fromUInt32(b)))), toUInt64_unchecked(fromUInt32((cin_1 & 1) >>> 0))));
                                const cout = ((toUInt32_unchecked(toUInt64_unchecked(op_RightShift(sumInt, w_5))) >>> 0) & 1) >>> 0;
                                patternInput_3 = [convertIntToFastData(w_5, toUInt32_unchecked(sumInt) >>> 0), (cout === 0) ? (new FData(/* Data */ 0, [new FastData(new FastBits(/* Word */ 0, [0]), 1)])) : (new FData(/* Data */ 0, [new FastData(new FastBits(/* Word */ 0, [1]), 1)]))];
                            }
                            else {
                                const sumInt_1 = (((a & mask) >>> 0) + ((b & mask) >>> 0)) + ((cin_1 & 1) >>> 0);
                                const cout_1 = ((sumInt_1 >>> w_5) & 1) >>> 0;
                                patternInput_3 = [convertIntToFastData(w_5, (sumInt_1 & mask) >>> 0), (cout_1 === 0) ? (new FData(/* Data */ 0, [new FastData(new FastBits(/* Word */ 0, [0]), 1)])) : (new FData(/* Data */ 0, [new FastData(new FastBits(/* Word */ 0, [1]), 1)]))];
                            }
                            break;
                        }
                        default:
                            patternInput_3 = toFail(`Inconsistent inputs to NBitsAdder ${comp.FullName} A=${a_1},${aIn}; B=${b_1},${bIn}`);
                    }
                    const sum_2 = patternInput_3[0];
                    if (componentType.tag === 17) {
                        item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Data */ 0, [sum_2]));
                        item(1, comp.Outputs).FDataStep[simStep] = patternInput_3[1];
                    }
                    else {
                        item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Data */ 0, [sum_2]));
                    }
                    break;
                }
                case 1: {
                    const matchValue_55 = FData__get_toExp(cin_2);
                    const newExp_1 = new FastAlgExp(/* BinaryExp */ 3, [new FastAlgExp(/* BinaryExp */ 3, [FData__get_toExp(aIn_1), BinaryOp.AddOp, FData__get_toExp(bIn_1)]), BinaryOp.AddOp, matchValue_55]);
                    const out0_3 = newExp_1;
                    if (componentType.tag === 17) {
                        item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Alg */ 1, [out0_3]));
                        item(1, comp.Outputs).FDataStep[simStep] = (new FData(/* Alg */ 1, [new FastAlgExp(/* UnaryExp */ 2, [UnaryOp.CarryOfOp, newExp_1])]));
                    }
                    else {
                        item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Alg */ 1, [out0_3]));
                    }
                    break;
                }
            }
            break;
        }
        case 20: {
            const matchValue_58 = item(simStep, item(0, comp.InputLinks).FDataStep);
            const matchValue_59 = item(simStep, item(1, comp.InputLinks).FDataStep);
            let matchResult_4, aIn_2, bIn_2, aIn_3, bIn_3;
            if (matchValue_58.tag === 0) {
                if (matchValue_59.tag === 0) {
                    matchResult_4 = 0;
                    aIn_2 = matchValue_58.fields[0];
                    bIn_2 = matchValue_59.fields[0];
                }
                else {
                    matchResult_4 = 1;
                    aIn_3 = matchValue_58;
                    bIn_3 = matchValue_59;
                }
            }
            else {
                matchResult_4 = 1;
                aIn_3 = matchValue_58;
                bIn_3 = matchValue_59;
            }
            switch (matchResult_4) {
                case 0: {
                    let patternInput_5;
                    const w_6 = aIn_2.Width | 0;
                    const matchValue_61 = aIn_2.Dat;
                    const matchValue_62 = bIn_2.Dat;
                    let matchResult_5, a_2, b_2, a_3, b_3;
                    if (matchValue_61.tag === 0) {
                        if (matchValue_62.tag === 0) {
                            matchResult_5 = 0;
                            a_2 = matchValue_61.fields[0];
                            b_2 = matchValue_62.fields[0];
                        }
                        else {
                            matchResult_5 = 1;
                            a_3 = matchValue_61;
                            b_3 = matchValue_62;
                        }
                    }
                    else {
                        matchResult_5 = 1;
                        a_3 = matchValue_61;
                        b_3 = matchValue_62;
                    }
                    switch (matchResult_5) {
                        case 0: {
                            const mask_1 = ((1 << w_6) >>> 0) - 1;
                            if (w_6 === 32) {
                                const sumInt_2 = toUInt64_unchecked(op_Addition(toUInt64_unchecked(op_Addition(toUInt64_unchecked(fromUInt32(a_2)), toUInt64_unchecked(fromUInt32(b_2)))), toUInt64_unchecked(fromUInt32((0 & 1) >>> 0))));
                                const cout_3 = ((toUInt32_unchecked(toUInt64_unchecked(op_RightShift(sumInt_2, w_6))) >>> 0) & 1) >>> 0;
                                patternInput_5 = [convertIntToFastData(w_6, toUInt32_unchecked(sumInt_2) >>> 0), (cout_3 === 0) ? (new FData(/* Data */ 0, [new FastData(new FastBits(/* Word */ 0, [0]), 1)])) : (new FData(/* Data */ 0, [new FastData(new FastBits(/* Word */ 0, [1]), 1)]))];
                            }
                            else {
                                const sumInt_3 = (((a_2 & mask_1) >>> 0) + ((b_2 & mask_1) >>> 0)) + ((0 & 1) >>> 0);
                                const cout_4 = ((sumInt_3 >>> w_6) & 1) >>> 0;
                                patternInput_5 = [convertIntToFastData(w_6, (sumInt_3 & mask_1) >>> 0), (cout_4 === 0) ? (new FData(/* Data */ 0, [new FastData(new FastBits(/* Word */ 0, [0]), 1)])) : (new FData(/* Data */ 0, [new FastData(new FastBits(/* Word */ 0, [1]), 1)]))];
                            }
                            break;
                        }
                        default:
                            patternInput_5 = toFail(`Inconsistent inputs to NBitsAdder ${comp.FullName} A=${a_3},${aIn_2}; B=${b_3},${bIn_2}`);
                    }
                    const sum_5 = patternInput_5[0];
                    if (componentType.tag === 18) {
                        item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Data */ 0, [sum_5]));
                        item(1, comp.Outputs).FDataStep[simStep] = patternInput_5[1];
                    }
                    else {
                        item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Data */ 0, [sum_5]));
                    }
                    break;
                }
                case 1: {
                    const newExp_2 = new FastAlgExp(/* BinaryExp */ 3, [FData__get_toExp(aIn_3), BinaryOp.AddOp, FData__get_toExp(bIn_3)]);
                    const out0_4 = newExp_2;
                    if (componentType.tag === 18) {
                        item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Alg */ 1, [out0_4]));
                        item(1, comp.Outputs).FDataStep[simStep] = (new FData(/* Alg */ 1, [new FastAlgExp(/* UnaryExp */ 2, [UnaryOp.CarryOfOp, newExp_2])]));
                    }
                    else {
                        item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Alg */ 1, [out0_4]));
                    }
                    break;
                }
            }
            break;
        }
        case 21: {
            const op = componentType.fields[1];
            const matchValue_66 = item(simStep, item(0, comp.InputLinks).FDataStep);
            const matchValue_67 = item(simStep, item(1, comp.InputLinks).FDataStep);
            let matchResult_6, aIn_4, bIn_4, aIn_5, bIn_5;
            if (matchValue_66.tag === 0) {
                if (matchValue_67.tag === 0) {
                    matchResult_6 = 0;
                    aIn_4 = matchValue_66.fields[0];
                    bIn_4 = matchValue_67.fields[0];
                }
                else {
                    matchResult_6 = 1;
                    aIn_5 = matchValue_66;
                    bIn_5 = matchValue_67;
                }
            }
            else {
                matchResult_6 = 1;
                aIn_5 = matchValue_66;
                bIn_5 = matchValue_67;
            }
            switch (matchResult_6) {
                case 0: {
                    const fd_102 = new FData(/* Data */ 0, [new FastData((matchValue_69 = aIn_4.Dat, (matchValue_70 = bIn_4.Dat, (matchValue_69.tag === 0) ? ((matchValue_70.tag === 0) ? (new FastBits(/* Word */ 0, [(op != null) ? ((matchValue_72 = (aIn_4.Width | 0), (matchValue_72 === 32) ? (matchValue_69.fields[0] * matchValue_70.fields[0]) : (((matchValue_69.fields[0] * matchValue_70.fields[0]) & (((1 << matchValue_72) >>> 0) - 1)) >>> 0))) : ((matchValue_69.fields[0] ^ matchValue_70.fields[0]) >>> 0)])) : toFail(`Inconsistent inputs to NBitsXOr ${comp.FullName} A=${matchValue_69},${aIn_4}; B=${matchValue_70},${bIn_4}`)) : toFail(`Inconsistent inputs to NBitsXOr ${comp.FullName} A=${matchValue_69},${aIn_4}; B=${matchValue_70},${bIn_4}`))), aIn_4.Width)]);
                    item(0, comp.Outputs).FDataStep[simStep] = fd_102;
                    break;
                }
                case 1: {
                    if (op == null) {
                        let matchResult_7, exp_17, num, w_8, aIn_6, bIn_6;
                        if (aIn_5.tag === 0) {
                            if (aIn_5.fields[0].Dat.tag === 0) {
                                if (bIn_5.tag === 1) {
                                    matchResult_7 = 0;
                                    exp_17 = bIn_5.fields[0];
                                    num = aIn_5.fields[0].Dat.fields[0];
                                    w_8 = aIn_5.fields[0].Width;
                                }
                                else {
                                    matchResult_7 = 1;
                                    aIn_6 = aIn_5;
                                    bIn_6 = bIn_5;
                                }
                            }
                            else {
                                matchResult_7 = 1;
                                aIn_6 = aIn_5;
                                bIn_6 = bIn_5;
                            }
                        }
                        else if (bIn_5.tag === 0) {
                            if (bIn_5.fields[0].Dat.tag === 0) {
                                matchResult_7 = 0;
                                exp_17 = aIn_5.fields[0];
                                num = bIn_5.fields[0].Dat.fields[0];
                                w_8 = bIn_5.fields[0].Width;
                            }
                            else {
                                matchResult_7 = 1;
                                aIn_6 = aIn_5;
                                bIn_6 = bIn_5;
                            }
                        }
                        else {
                            matchResult_7 = 1;
                            aIn_6 = aIn_5;
                            bIn_6 = bIn_5;
                        }
                        switch (matchResult_7) {
                            case 0: {
                                if (num === (toUInt32(bigIntMask(w_8)) >>> 0)) {
                                    item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Alg */ 1, [new FastAlgExp(/* UnaryExp */ 2, [UnaryOp.NotOp, exp_17])]));
                                }
                                else if (num === 0) {
                                    item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Alg */ 1, [exp_17]));
                                }
                                else {
                                    const numExp = FData__get_toExp(new FData(/* Data */ 0, [new FastData(new FastBits(/* Word */ 0, [num]), w_8)]));
                                    item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Alg */ 1, [new FastAlgExp(/* BinaryExp */ 3, [exp_17, BinaryOp.BitXorOp, numExp])]));
                                }
                                break;
                            }
                            case 1: {
                                const matchValue_74 = FData__get_toExp(aIn_6);
                                const matchValue_75 = FData__get_toExp(bIn_6);
                                item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Alg */ 1, [new FastAlgExp(/* BinaryExp */ 3, [matchValue_74, BinaryOp.BitXorOp, matchValue_75])]));
                                break;
                            }
                        }
                    }
                    else {
                        throw new AlgebraNotImplemented(new SimulationError(new SimulationErrorType(/* AlgInpNotAllowed */ 15, ["The chosen set of Algebraic inputs results in algebra being passed to a\r\n                        multiply block. Algebraic multiplication cannot be represented, so only values can be passed to its ports."]), comp.FullName, singleton(comp.cId), empty()));
                    }
                    break;
                }
            }
            break;
        }
        case 22: {
            const matchValue_76 = item(simStep, item(0, comp.InputLinks).FDataStep);
            const matchValue_77 = item(simStep, item(1, comp.InputLinks).FDataStep);
            let matchResult_8, aIn_7, bIn_7, exp_18, num_1, w_9, aIn_8, bIn_8;
            if (matchValue_76.tag === 1) {
                if (matchValue_77.tag === 0) {
                    if (matchValue_77.fields[0].Dat.tag === 0) {
                        matchResult_8 = 1;
                        exp_18 = matchValue_76.fields[0];
                        num_1 = matchValue_77.fields[0].Dat.fields[0];
                        w_9 = matchValue_77.fields[0].Width;
                    }
                    else {
                        matchResult_8 = 2;
                        aIn_8 = matchValue_76;
                        bIn_8 = matchValue_77;
                    }
                }
                else {
                    matchResult_8 = 2;
                    aIn_8 = matchValue_76;
                    bIn_8 = matchValue_77;
                }
            }
            else if (matchValue_77.tag === 1) {
                if (matchValue_76.fields[0].Dat.tag === 0) {
                    matchResult_8 = 1;
                    exp_18 = matchValue_77.fields[0];
                    num_1 = matchValue_76.fields[0].Dat.fields[0];
                    w_9 = matchValue_76.fields[0].Width;
                }
                else {
                    matchResult_8 = 2;
                    aIn_8 = matchValue_76;
                    bIn_8 = matchValue_77;
                }
            }
            else {
                matchResult_8 = 0;
                aIn_7 = matchValue_76.fields[0];
                bIn_7 = matchValue_77.fields[0];
            }
            switch (matchResult_8) {
                case 0: {
                    const fd_109 = new FData(/* Data */ 0, [new FastData((matchValue_79 = aIn_7.Dat, (matchValue_80 = bIn_7.Dat, (matchValue_79.tag === 0) ? ((matchValue_80.tag === 0) ? (new FastBits(/* Word */ 0, [(matchValue_79.fields[0] | matchValue_80.fields[0]) >>> 0])) : toFail(`Inconsistent inputs to NBitsXOr ${comp.FullName} A=${matchValue_79},${aIn_7}; B=${matchValue_80},${bIn_7}`)) : toFail(`Inconsistent inputs to NBitsXOr ${comp.FullName} A=${matchValue_79},${aIn_7}; B=${matchValue_80},${bIn_7}`))), aIn_7.Width)]);
                    item(0, comp.Outputs).FDataStep[simStep] = fd_109;
                    break;
                }
                case 1: {
                    if (num_1 === 0) {
                        item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Alg */ 1, [exp_18]));
                    }
                    else if (num_1 === (toUInt32(bigIntMask(w_9)) >>> 0)) {
                        const fd_111 = new FData(/* Alg */ 1, [FData__get_toExp(new FData(/* Data */ 0, [new FastData(new FastBits(/* Word */ 0, [num_1]), w_9)]))]);
                        item(0, comp.Outputs).FDataStep[simStep] = fd_111;
                    }
                    else {
                        const numExp_1 = FData__get_toExp(new FData(/* Data */ 0, [new FastData(new FastBits(/* Word */ 0, [num_1]), w_9)]));
                        item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Alg */ 1, [new FastAlgExp(/* BinaryExp */ 3, [exp_18, BinaryOp.BitOrOp, numExp_1])]));
                    }
                    break;
                }
                case 2: {
                    const matchValue_82 = FData__get_toExp(aIn_8);
                    const matchValue_83 = FData__get_toExp(bIn_8);
                    item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Alg */ 1, [new FastAlgExp(/* BinaryExp */ 3, [matchValue_82, BinaryOp.BitOrOp, matchValue_83])]));
                    break;
                }
            }
            break;
        }
        case 23: {
            const matchValue_84 = item(simStep, item(0, comp.InputLinks).FDataStep);
            const matchValue_85 = item(simStep, item(1, comp.InputLinks).FDataStep);
            let matchResult_9, aIn_9, bIn_9, exp_19, num_2, w_10, aIn_10, bIn_10;
            if (matchValue_84.tag === 1) {
                if (matchValue_85.tag === 0) {
                    if (matchValue_85.fields[0].Dat.tag === 0) {
                        matchResult_9 = 1;
                        exp_19 = matchValue_84.fields[0];
                        num_2 = matchValue_85.fields[0].Dat.fields[0];
                        w_10 = matchValue_85.fields[0].Width;
                    }
                    else {
                        matchResult_9 = 2;
                        aIn_10 = matchValue_84;
                        bIn_10 = matchValue_85;
                    }
                }
                else {
                    matchResult_9 = 2;
                    aIn_10 = matchValue_84;
                    bIn_10 = matchValue_85;
                }
            }
            else if (matchValue_85.tag === 1) {
                if (matchValue_84.fields[0].Dat.tag === 0) {
                    matchResult_9 = 1;
                    exp_19 = matchValue_85.fields[0];
                    num_2 = matchValue_84.fields[0].Dat.fields[0];
                    w_10 = matchValue_84.fields[0].Width;
                }
                else {
                    matchResult_9 = 2;
                    aIn_10 = matchValue_84;
                    bIn_10 = matchValue_85;
                }
            }
            else {
                matchResult_9 = 0;
                aIn_9 = matchValue_84.fields[0];
                bIn_9 = matchValue_85.fields[0];
            }
            switch (matchResult_9) {
                case 0: {
                    const fd_116 = new FData(/* Data */ 0, [new FastData((matchValue_87 = aIn_9.Dat, (matchValue_88 = bIn_9.Dat, (matchValue_87.tag === 0) ? ((matchValue_88.tag === 0) ? (new FastBits(/* Word */ 0, [(matchValue_87.fields[0] & matchValue_88.fields[0]) >>> 0])) : toFail(`Inconsistent inputs to NBitsAnd ${comp.FullName} A=${matchValue_87},${aIn_9}; B=${matchValue_88},${bIn_9}`)) : toFail(`Inconsistent inputs to NBitsAnd ${comp.FullName} A=${matchValue_87},${aIn_9}; B=${matchValue_88},${bIn_9}`))), aIn_9.Width)]);
                    item(0, comp.Outputs).FDataStep[simStep] = fd_116;
                    break;
                }
                case 1: {
                    if (num_2 === (toUInt32(bigIntMask(w_10)) >>> 0)) {
                        item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Alg */ 1, [exp_19]));
                    }
                    else if (num_2 === 0) {
                        const fd_118 = new FData(/* Alg */ 1, [FData__get_toExp(new FData(/* Data */ 0, [new FastData(new FastBits(/* Word */ 0, [0]), w_10)]))]);
                        item(0, comp.Outputs).FDataStep[simStep] = fd_118;
                    }
                    else {
                        const numExp_2 = FData__get_toExp(new FData(/* Data */ 0, [new FastData(new FastBits(/* Word */ 0, [num_2]), w_10)]));
                        item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Alg */ 1, [new FastAlgExp(/* BinaryExp */ 3, [exp_19, BinaryOp.BitAndOp, numExp_2])]));
                    }
                    break;
                }
                case 2: {
                    const matchValue_90 = FData__get_toExp(aIn_10);
                    const matchValue_91 = FData__get_toExp(bIn_10);
                    item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Alg */ 1, [new FastAlgExp(/* BinaryExp */ 3, [matchValue_90, BinaryOp.BitAndOp, matchValue_91])]));
                    break;
                }
            }
            break;
        }
        case 24: {
            const matchValue_92 = item(simStep, item(0, comp.InputLinks).FDataStep);
            if (matchValue_92.tag === 1) {
                item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Alg */ 1, [new FastAlgExp(/* UnaryExp */ 2, [UnaryOp.NotOp, matchValue_92.fields[0]])]));
            }
            else {
                const aIn_11 = matchValue_92.fields[0];
                const fd_122 = new FData(/* Data */ 0, [new FastData((matchValue_93 = aIn_11.Dat, (matchValue_93.tag === 0) ? ((a_10 = matchValue_93.fields[0], (matchValue_94 = (aIn_11.Width | 0), (matchValue_94 === 32) ? (new FastBits(/* Word */ 0, [~a_10 >>> 0])) : (new FastBits(/* Word */ 0, [((((1 << matchValue_94) >>> 0) - 1) & (~a_10 >>> 0)) >>> 0]))))) : tooWideForTable(aIn_11)), aIn_11.Width)]);
                item(0, comp.Outputs).FDataStep[simStep] = fd_122;
            }
            break;
        }
        case 25: {
            const numberOfBits_6 = componentType.fields[0] | 0;
            const matchValue_95 = item(simStep, item(0, comp.InputLinks).FDataStep);
            if (matchValue_95.tag === 1) {
                const exp_22 = matchValue_95.fields[0];
                if (numberOfBits_6 === 1) {
                    item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Alg */ 1, [exp_22]));
                }
                else {
                    const fd_127 = new FData(/* Alg */ 1, [new FastAlgExp(/* AppendExp */ 5, [replicate(numberOfBits_6, exp_22)])]);
                    item(0, comp.Outputs).FDataStep[simStep] = fd_127;
                }
            }
            else {
                let outDat_4;
                const matchValue_96 = convertFastDataToInt(matchValue_95.fields[0]);
                outDat_4 = ((matchValue_96 === 0) ? convertIntToFastData(numberOfBits_6, 0) : ((matchValue_96 === 1) ? ((numberOfBits_6 <= 32) ? convertIntToFastData(numberOfBits_6, (numberOfBits_6 !== 32) ? (((1 << numberOfBits_6) >>> 0) - 1) : 4294967295) : convertBigintToFastData(numberOfBits_6, op_Subtraction(op_LeftShift(fromOne(), numberOfBits_6), fromOne()))) : toFail(printf("Can\'t happen"))));
                item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Data */ 0, [outDat_4]));
            }
            break;
        }
        case 26: {
            const width_11 = componentType.fields[0] | 0;
            const shiftType = componentType.fields[2];
            const matchValue_97 = item(simStep, item(0, comp.InputLinks).FDataStep);
            const matchValue_98 = item(simStep, item(1, comp.InputLinks).FDataStep);
            let matchResult_10, amtIn, bitsIn, amtIn_1, exp_23;
            if (matchValue_97.tag === 1) {
                if (matchValue_98.tag === 0) {
                    matchResult_10 = 1;
                    amtIn_1 = matchValue_98.fields[0];
                    exp_23 = matchValue_97.fields[0];
                }
                else {
                    matchResult_10 = 2;
                }
            }
            else if (matchValue_98.tag === 0) {
                matchResult_10 = 0;
                amtIn = matchValue_98.fields[0];
                bitsIn = matchValue_97.fields[0];
            }
            else {
                matchResult_10 = 2;
            }
            switch (matchResult_10) {
                case 0: {
                    const mask_2 = op_Subtraction(op_LeftShift(fromOne(), width_11), fromOne());
                    const bits_15 = op_BitwiseAnd((matchValue_100 = bitsIn.Dat, (matchValue_100.tag === 1) ? matchValue_100.fields[0] : fromUInt32(matchValue_100.fields[0])), mask_2);
                    const amt = convertFastDataToInt(amtIn);
                    const signSet = equals(op_BitwiseAnd(op_RightShift(bits_15, width_11 - 1), fromOne()), fromOne());
                    const fd_130 = new FData(/* Data */ 0, [convertBigintToFastData(width_11, (amt >= (width_11 >>> 0)) ? ((shiftType.tag === 1) ? fromZero() : ((shiftType.tag === 2) ? (signSet ? mask_2 : fromZero()) : fromZero())) : ((amt_1 = (~~amt | 0), (shiftType.tag === 1) ? op_RightShift(bits_15, amt_1) : ((shiftType.tag === 2) ? (signSet ? op_BitwiseOr(op_RightShift(bits_15, amt_1), op_BitwiseAnd(mask_2, op_LeftShift(mask_2, width_11 - amt_1))) : op_RightShift(bits_15, amt_1)) : op_BitwiseAnd(op_LeftShift(bits_15, amt_1), mask_2)))))]);
                    item(0, comp.Outputs).FDataStep[simStep] = fd_130;
                    break;
                }
                case 1: {
                    const amt_2 = convertFastDataToInt(amtIn_1);
                    const signBit = new FastAlgExp(/* UnaryExp */ 2, [new UnaryOp(/* BitRangeOp */ 2, [width_11 - 1, width_11 - 1]), exp_23]);
                    let res_1;
                    if (amt_2 === 0) {
                        res_1 = exp_23;
                    }
                    else if (amt_2 >= (width_11 >>> 0)) {
                        switch (shiftType.tag) {
                            case 2: {
                                res_1 = (new FastAlgExp(/* AppendExp */ 5, [replicate(width_11, signBit)]));
                                break;
                            }
                            default:
                                res_1 = zeroLiteral(width_11);
                        }
                    }
                    else {
                        const amt_3 = ~~amt_2 | 0;
                        res_1 = ((shiftType.tag === 1) ? (new FastAlgExp(/* AppendExp */ 5, [ofArray([zeroLiteral(amt_3), new FastAlgExp(/* UnaryExp */ 2, [new UnaryOp(/* BitRangeOp */ 2, [amt_3, width_11 - 1]), exp_23])])])) : ((shiftType.tag === 2) ? (new FastAlgExp(/* AppendExp */ 5, [append(replicate(amt_3, signBit), singleton(new FastAlgExp(/* UnaryExp */ 2, [new UnaryOp(/* BitRangeOp */ 2, [amt_3, width_11 - 1]), exp_23])))])) : (new FastAlgExp(/* AppendExp */ 5, [ofArray([new FastAlgExp(/* UnaryExp */ 2, [new UnaryOp(/* BitRangeOp */ 2, [0, (width_11 - 1) - amt_3]), exp_23]), zeroLiteral(amt_3)])]))));
                    }
                    item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Alg */ 1, [res_1]));
                    break;
                }
                case 2: {
                    throw new AlgebraNotImplemented(new SimulationError(new SimulationErrorType(/* AlgInpNotAllowed */ 15, ["The chosen set of Algebraic inputs results in algebra being passed to the\r\n                    SHIFT (shift amount) port of a Shifter. Only values can be passed to this port."]), comp.FullName, singleton(comp.cId), empty()));
                    break;
                }
            }
            break;
        }
        case 27: {
            toFail(printf("what? Custom components are removed before the fast simulation: %A"))(componentType.fields[0]);
            break;
        }
        case 28: {
            const matchValue_101 = item(simStep, item(0, comp.InputLinks).FDataStep);
            const matchValue_102 = item(simStep, item(1, comp.InputLinks).FDataStep);
            let matchResult_11, bits0_1, bits1_1, exps0, exps1, exps0_1, fd1_2, exps1_1, fd0_2, fd0_3, fd1_3;
            if (matchValue_101.tag === 1) {
                if (matchValue_101.fields[0].tag === 5) {
                    if (matchValue_102.tag === 1) {
                        if (matchValue_102.fields[0].tag === 5) {
                            matchResult_11 = 1;
                            exps0 = matchValue_101.fields[0].fields[0];
                            exps1 = matchValue_102.fields[0].fields[0];
                        }
                        else {
                            matchResult_11 = 2;
                            exps0_1 = matchValue_101.fields[0].fields[0];
                            fd1_2 = matchValue_102;
                        }
                    }
                    else {
                        matchResult_11 = 2;
                        exps0_1 = matchValue_101.fields[0].fields[0];
                        fd1_2 = matchValue_102;
                    }
                }
                else if (matchValue_102.tag === 1) {
                    if (matchValue_102.fields[0].tag === 5) {
                        matchResult_11 = 3;
                        exps1_1 = matchValue_102.fields[0].fields[0];
                        fd0_2 = matchValue_101;
                    }
                    else {
                        matchResult_11 = 4;
                        fd0_3 = matchValue_101;
                        fd1_3 = matchValue_102;
                    }
                }
                else {
                    matchResult_11 = 4;
                    fd0_3 = matchValue_101;
                    fd1_3 = matchValue_102;
                }
            }
            else if (matchValue_102.tag === 1) {
                if (matchValue_102.fields[0].tag === 5) {
                    matchResult_11 = 3;
                    exps1_1 = matchValue_102.fields[0].fields[0];
                    fd0_2 = matchValue_101;
                }
                else {
                    matchResult_11 = 4;
                    fd0_3 = matchValue_101;
                    fd1_3 = matchValue_102;
                }
            }
            else {
                matchResult_11 = 0;
                bits0_1 = matchValue_101.fields[0];
                bits1_1 = matchValue_102.fields[0];
            }
            switch (matchResult_11) {
                case 0: {
                    const wOut = (bits0_1.Width + bits1_1.Width) | 0;
                    let outBits_1;
                    const matchValue_104 = bits0_1.Dat;
                    const matchValue_105 = bits1_1.Dat;
                    let matchResult_12, b0, b1;
                    if (matchValue_104.tag === 0) {
                        if (matchValue_105.tag === 0) {
                            matchResult_12 = 0;
                            b0 = matchValue_104.fields[0];
                            b1 = matchValue_105.fields[0];
                        }
                        else {
                            matchResult_12 = 1;
                        }
                    }
                    else {
                        matchResult_12 = 1;
                    }
                    switch (matchResult_12) {
                        case 0: {
                            outBits_1 = convertIntToFastData(wOut, (((b1 << bits0_1.Width) >>> 0) | b0) >>> 0);
                            break;
                        }
                        default:
                            outBits_1 = toFail(`inconsistent merge widths: ${bits0_1},${bits1_1}`);
                    }
                    item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Data */ 0, [outBits_1]));
                    break;
                }
                case 1: {
                    const newExp_3 = new FastAlgExp(/* AppendExp */ 5, [foldAppends(append(exps1, exps0))]);
                    item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Alg */ 1, [newExp_3]));
                    break;
                }
                case 2: {
                    const newExp_4 = new FastAlgExp(/* AppendExp */ 5, [foldAppends(cons(FData__get_toExp(fd1_2), exps0_1))]);
                    item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Alg */ 1, [newExp_4]));
                    break;
                }
                case 3: {
                    const newExp_5 = new FastAlgExp(/* AppendExp */ 5, [foldAppends(append(exps1_1, singleton(FData__get_toExp(fd0_2))))]);
                    item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Alg */ 1, [newExp_5]));
                    break;
                }
                case 4: {
                    const matchValue_107 = FData__get_toExp(fd0_3);
                    const newExp_6 = new FastAlgExp(/* AppendExp */ 5, [foldAppends(ofArray([FData__get_toExp(fd1_3), matchValue_107]))]);
                    item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Alg */ 1, [newExp_6]));
                    break;
                }
            }
            break;
        }
        case 29: {
            const fDataL = map((i_50) => item(simStep, item(i_50, comp.InputLinks).FDataStep), toList(rangeDouble(0, 1, componentType.fields[0] - 1)));
            if (forAll((fdata) => {
                if (fdata.tag === 0) {
                    return true;
                }
                else {
                    return false;
                }
            }, fDataL)) {
                const bitsList = map((n_97) => ((n_97.tag === 0) ? n_97.fields[0] : toFail(printf("Cannot simulate truth tables with merge inputs part-algebraic"))), fDataL);
                const outBits_2 = convertIntToFastData(sumBy((bits_17) => (bits_17.Width | 0), bitsList, {
                    GetZero: () => 0,
                    Add: (x_3, y) => ((x_3 + y) | 0),
                }), fold((tupledArg, tupledArg_1) => {
                    const lSWidth = tupledArg[1] | 0;
                    return [(((tupledArg_1[0] << lSWidth) >>> 0) | tupledArg[0]) >>> 0, tupledArg_1[1] + lSWidth];
                }, [0, 0], map((bits_18) => {
                    const matchValue_109 = bits_18.Dat;
                    if (matchValue_109.tag === 1) {
                        return tooWideForTable(bits_18);
                    }
                    else {
                        return [matchValue_109.fields[0], bits_18.Width];
                    }
                }, bitsList))[0]);
                item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Data */ 0, [outBits_2]));
            }
            else {
                const fd_142 = new FData(/* Alg */ 1, [new FastAlgExp(/* AppendExp */ 5, [foldAppends(fold((acc, data) => {
                    let matchResult_13, exps, fd_141;
                    if (data.tag === 1) {
                        if (data.fields[0].tag === 5) {
                            matchResult_13 = 0;
                            exps = data.fields[0].fields[0];
                        }
                        else {
                            matchResult_13 = 1;
                            fd_141 = data;
                        }
                    }
                    else {
                        matchResult_13 = 1;
                        fd_141 = data;
                    }
                    switch (matchResult_13) {
                        case 0:
                            return append(exps, acc);
                        default:
                            return cons(FData__get_toExp(fd_141), acc);
                    }
                }, empty(), fDataL))])]);
                item(0, comp.Outputs).FDataStep[simStep] = fd_142;
            }
            break;
        }
        case 30: {
            const fDataL_1 = map((i_51) => item(simStep, item(i_51, comp.InputLinks).FDataStep), toList(rangeDouble(0, 1, componentType.fields[0] - 1)));
            if (forAll((fd_144) => {
                if (fd_144.tag === 0) {
                    return true;
                }
                else {
                    return false;
                }
            }, fDataL_1)) {
                const bitsList_1 = map((fd_145) => {
                    if (fd_145.tag === 0) {
                        return fd_145.fields[0];
                    }
                    else {
                        return toFail(printf("Cannot simulate truth tables with array merge inputs part-algebraic"));
                    }
                }, fDataL_1);
                const outBits_3 = convertIntToFastData(sumBy((bits_20) => (bits_20.Width | 0), bitsList_1, {
                    GetZero: () => 0,
                    Add: (x_4, y_1) => ((x_4 + y_1) | 0),
                }), fold((tupledArg_3, tupledArg_4) => {
                    const lSWidth_1 = tupledArg_3[1] | 0;
                    return [(((tupledArg_4[0] << lSWidth_1) >>> 0) | tupledArg_3[0]) >>> 0, tupledArg_4[1] + lSWidth_1];
                }, [0, 0], map((bits_21) => {
                    const matchValue_111 = bits_21.Dat;
                    if (matchValue_111.tag === 1) {
                        return tooWideForTable(bits_21);
                    }
                    else {
                        return [matchValue_111.fields[0], bits_21.Width];
                    }
                }, bitsList_1))[0]);
                item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Data */ 0, [outBits_3]));
            }
            else {
                const fd_148 = new FData(/* Alg */ 1, [new FastAlgExp(/* AppendExp */ 5, [foldAppends(fold((acc_1, data_1) => {
                    let matchResult_14, exps_1, fd_147;
                    if (data_1.tag === 1) {
                        if (data_1.fields[0].tag === 5) {
                            matchResult_14 = 0;
                            exps_1 = data_1.fields[0].fields[0];
                        }
                        else {
                            matchResult_14 = 1;
                            fd_147 = data_1;
                        }
                    }
                    else {
                        matchResult_14 = 1;
                        fd_147 = data_1;
                    }
                    switch (matchResult_14) {
                        case 0:
                            return append(exps_1, acc_1);
                        default:
                            return cons(FData__get_toExp(fd_147), acc_1);
                    }
                }, empty(), fDataL_1))])]);
                item(0, comp.Outputs).FDataStep[simStep] = fd_148;
            }
            break;
        }
        case 31: {
            const n_104 = componentType.fields[0] | 0;
            const matchValue_112 = item(simStep, item(n_104, comp.InputLinks).FDataStep);
            if (matchValue_112.tag === 1) {
                throw new AlgebraNotImplemented(new SimulationError(new SimulationErrorType(/* AlgInpNotAllowed */ 15, ["The chosen set of Algebraic inputs results in algebra being passed to the\r\n                    SEL port of an array multiplexer. Only values can be passed to this port."]), comp.FullName, singleton(comp.cId), empty()));
            }
            else {
                const sel = convertFastDataToInt(matchValue_112.fields[0]);
                if (sel < (n_104 >>> 0)) {
                    const fd_150 = item(simStep, item(~~sel, comp.InputLinks).FDataStep);
                    item(0, comp.Outputs).FDataStep[simStep] = fd_150;
                }
                else {
                    const fd_152 = new FData(/* Data */ 0, [convertIntToFastData(getAlgExpWidth(FData__get_toExp(item(simStep, item(0, comp.InputLinks).FDataStep))), 0)]);
                    item(0, comp.Outputs).FDataStep[simStep] = fd_152;
                }
            }
            break;
        }
        case 32: {
            const topWireWidth = componentType.fields[0] | 0;
            const fd_155 = item(simStep, item(0, comp.InputLinks).FDataStep);
            let matchResult_15, bits_22, exp_24, l_1, u_1, exp_25, exp_26;
            if (fd_155.tag === 1) {
                if (fd_155.fields[0].tag === 2) {
                    switch (fd_155.fields[0].fields[0].tag) {
                        case 2: {
                            matchResult_15 = 1;
                            exp_24 = fd_155.fields[0].fields[1];
                            l_1 = fd_155.fields[0].fields[0].fields[0];
                            u_1 = fd_155.fields[0].fields[0].fields[1];
                            break;
                        }
                        case 1: {
                            matchResult_15 = 2;
                            exp_25 = fd_155.fields[0].fields[1];
                            break;
                        }
                        default: {
                            matchResult_15 = 3;
                            exp_26 = fd_155.fields[0];
                        }
                    }
                }
                else {
                    matchResult_15 = 3;
                    exp_26 = fd_155.fields[0];
                }
            }
            else {
                matchResult_15 = 0;
                bits_22 = fd_155.fields[0];
            }
            switch (matchResult_15) {
                case 0: {
                    let patternInput_11;
                    const bits1_2 = getBits(bits_22.Width - 1, topWireWidth, bits_22);
                    patternInput_11 = [getBits(topWireWidth - 1, 0, bits_22), bits1_2];
                    item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Data */ 0, [patternInput_11[0]]));
                    item(1, comp.Outputs).FDataStep[simStep] = (new FData(/* Data */ 0, [patternInput_11[1]]));
                    break;
                }
                case 1: {
                    const exp1_6 = new FastAlgExp(/* UnaryExp */ 2, [new UnaryOp(/* BitRangeOp */ 2, [l_1 + topWireWidth, u_1]), exp_24]);
                    const exp0_2 = new FastAlgExp(/* UnaryExp */ 2, [new UnaryOp(/* BitRangeOp */ 2, [l_1, (l_1 + topWireWidth) - 1]), exp_24]);
                    item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Alg */ 1, [exp0_2]));
                    item(1, comp.Outputs).FDataStep[simStep] = (new FData(/* Alg */ 1, [exp1_6]));
                    break;
                }
                case 2: {
                    const exp1_7 = new FastAlgExp(/* UnaryExp */ 2, [new UnaryOp(/* BitRangeOp */ 2, [topWireWidth, getAlgExpWidth(new FastAlgExp(/* UnaryExp */ 2, [UnaryOp.NotOp, exp_25])) - 1]), exp_25]);
                    const exp0_3 = new FastAlgExp(/* UnaryExp */ 2, [new UnaryOp(/* BitRangeOp */ 2, [0, topWireWidth - 1]), exp_25]);
                    item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Alg */ 1, [new FastAlgExp(/* UnaryExp */ 2, [UnaryOp.NotOp, exp0_3])]));
                    item(1, comp.Outputs).FDataStep[simStep] = (new FData(/* Alg */ 1, [new FastAlgExp(/* UnaryExp */ 2, [UnaryOp.NotOp, exp1_7])]));
                    break;
                }
                case 3: {
                    const exp1_8 = new FastAlgExp(/* UnaryExp */ 2, [new UnaryOp(/* BitRangeOp */ 2, [topWireWidth, getAlgExpWidth(exp_26) - 1]), exp_26]);
                    const exp0_4 = new FastAlgExp(/* UnaryExp */ 2, [new UnaryOp(/* BitRangeOp */ 2, [0, topWireWidth - 1]), exp_26]);
                    item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Alg */ 1, [exp0_4]));
                    item(1, comp.Outputs).FDataStep[simStep] = (new FData(/* Alg */ 1, [exp1_8]));
                    break;
                }
            }
            break;
        }
        case 33: {
            const fd_165 = item(simStep, item(0, comp.InputLinks).FDataStep);
            iterateIndexed((i_57, tupledArg_6) => {
                const fd = fd_165;
                const outNum = i_57 | 0;
                const width = tupledArg_6[0] | 0;
                const lsb = tupledArg_6[1] | 0;
                let matchResult_16, bits_1, exp, l, u, exp_2, exp_4;
                if (fd.tag === 1) {
                    if (fd.fields[0].tag === 2) {
                        switch (fd.fields[0].fields[0].tag) {
                            case 2: {
                                matchResult_16 = 1;
                                exp = fd.fields[0].fields[1];
                                l = fd.fields[0].fields[0].fields[0];
                                u = fd.fields[0].fields[0].fields[1];
                                break;
                            }
                            case 1: {
                                matchResult_16 = 2;
                                exp_2 = fd.fields[0].fields[1];
                                break;
                            }
                            default: {
                                matchResult_16 = 3;
                                exp_4 = fd.fields[0];
                            }
                        }
                    }
                    else {
                        matchResult_16 = 3;
                        exp_4 = fd.fields[0];
                    }
                }
                else {
                    matchResult_16 = 0;
                    bits_1 = fd.fields[0];
                }
                switch (matchResult_16) {
                    case 0: {
                        const bits_2 = getBits((lsb + width) - 1, lsb, bits_1);
                        item(outNum, comp.Outputs).FDataStep[simStep] = (new FData(/* Data */ 0, [bits_2]));
                        break;
                    }
                    case 1: {
                        const exp_1 = new FastAlgExp(/* UnaryExp */ 2, [new UnaryOp(/* BitRangeOp */ 2, [l + lsb, ((l + lsb) + width) - 1]), exp]);
                        item(outNum, comp.Outputs).FDataStep[simStep] = (new FData(/* Alg */ 1, [exp_1]));
                        break;
                    }
                    case 2: {
                        getAlgExpWidth(new FastAlgExp(/* UnaryExp */ 2, [UnaryOp.NotOp, exp_2]));
                        const exp_3 = new FastAlgExp(/* UnaryExp */ 2, [new UnaryOp(/* BitRangeOp */ 2, [lsb, (lsb + width) - 1]), exp_2]);
                        item(outNum, comp.Outputs).FDataStep[simStep] = (new FData(/* Alg */ 1, [new FastAlgExp(/* UnaryExp */ 2, [UnaryOp.NotOp, exp_3])]));
                        break;
                    }
                    case 3: {
                        getAlgExpWidth(exp_4);
                        const exp_5 = new FastAlgExp(/* UnaryExp */ 2, [new UnaryOp(/* BitRangeOp */ 2, [lsb, (lsb + width) - 1]), exp_4]);
                        item(outNum, comp.Outputs).FDataStep[simStep] = (new FData(/* Alg */ 1, [exp_5]));
                        break;
                    }
                }
            }, zip(componentType.fields[1], componentType.fields[2]));
            break;
        }
        case 34: {
            const matchValue_113 = item(simStepOld, item(0, comp.InputLinks).FDataStep);
            if (matchValue_113.tag === 0) {
                const fd_168 = (((fd__10 = (new FData(/* Data */ 0, [matchValue_113.fields[0]])), (fd__10.tag === 0) ? ((fd_167 = fd__10.fields[0], (matchValue_114 = fd_167.Dat, (matchValue_114.tag === 1) ? toFail(`Can't extract ${interpolate("%d%P()", [1])} bit from BigWord data ${fd_167.Dat} of width ${fd_167.Width}`) : matchValue_114.fields[0]))) : toFail(printf("Can\'t extract data from Algebra")))) === 0) ? (new FData(/* Data */ 0, [new FastData(new FastBits(/* Word */ 0, [0]), 1)])) : (new FData(/* Data */ 0, [new FastData(new FastBits(/* Word */ 0, [1]), 1)]));
                item(0, comp.Outputs).FDataStep[simStep] = fd_168;
            }
            else {
                throw new AlgebraNotImplemented(new SimulationError(new SimulationErrorType(/* AlgInpNotAllowed */ 15, ["Algebraic Simulation not implemented for DFF."]), comp.FullName, singleton(comp.cId), empty()));
            }
            break;
        }
        case 35: {
            const matchValue_115 = item(simStepOld, item(0, comp.InputLinks).FDataStep);
            const matchValue_116 = item(simStepOld, item(1, comp.InputLinks).FDataStep);
            let matchResult_17, bits0_4, bits1_4;
            if (matchValue_115.tag === 0) {
                if (matchValue_116.tag === 0) {
                    matchResult_17 = 0;
                    bits0_4 = matchValue_115.fields[0];
                    bits1_4 = matchValue_116.fields[0];
                }
                else {
                    matchResult_17 = 1;
                }
            }
            else {
                matchResult_17 = 1;
            }
            switch (matchResult_17) {
                case 0: {
                    let matchValue_120;
                    const fd__11 = new FData(/* Data */ 0, [bits0_4]);
                    if (fd__11.tag === 0) {
                        const fd_171 = fd__11.fields[0];
                        const matchValue_118 = fd_171.Dat;
                        matchValue_120 = ((matchValue_118.tag === 1) ? toFail(`Can't extract ${interpolate("%d%P()", [1])} bit from BigWord data ${fd_171.Dat} of width ${fd_171.Width}`) : matchValue_118.fields[0]);
                    }
                    else {
                        matchValue_120 = toFail(printf("Can\'t extract data from Algebra"));
                    }
                    if (((fd__12 = (new FData(/* Data */ 0, [bits1_4])), (fd__12.tag === 0) ? ((fd_172 = fd__12.fields[0], (matchValue_119 = fd_172.Dat, (matchValue_119.tag === 1) ? toFail(`Can't extract ${interpolate("%d%P()", [1])} bit from BigWord data ${fd_172.Dat} of width ${fd_172.Width}`) : matchValue_119.fields[0]))) : toFail(printf("Can\'t extract data from Algebra")))) === 1) {
                        const fd_173 = (matchValue_120 === 0) ? (new FData(/* Data */ 0, [new FastData(new FastBits(/* Word */ 0, [0]), 1)])) : (new FData(/* Data */ 0, [new FastData(new FastBits(/* Word */ 0, [1]), 1)]));
                        item(0, comp.Outputs).FDataStep[simStep] = fd_173;
                    }
                    else {
                        let fd_174;
                        const matchValue_122 = item(0, comp.Outputs).Width | 0;
                        fd_174 = ((matchValue_122 === 0) ? toFail(printf("Can\'t reduce %A (%A) because outputwidth is not known"))(comp.FullName)(comp.FType) : ((numStep === 0) ? (new FData(/* Data */ 0, [new FastData(new FastBits(/* Word */ 0, [0]), matchValue_122)])) : item(simStepOld, item(0, comp.Outputs).FDataStep)));
                        item(0, comp.Outputs).FDataStep[simStep] = fd_174;
                    }
                    break;
                }
                case 1: {
                    throw new AlgebraNotImplemented(new SimulationError(new SimulationErrorType(/* AlgInpNotAllowed */ 15, ["The chosen set of Algebraic inputs results in algebra being passed to a\r\n                    DFFE. Algebraic Simulation has not been implemented for this component."]), comp.FullName, singleton(comp.cId), empty()));
                    break;
                }
            }
            break;
        }
        case 36: {
            const fd_177 = item(simStepOld, item(0, comp.InputLinks).FDataStep);
            if (fd_177.tag === 0) {
                item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Data */ 0, [fd_177.fields[0]]));
            }
            else {
                throw new AlgebraNotImplemented(new SimulationError(new SimulationErrorType(/* AlgInpNotAllowed */ 15, ["The chosen set of Algebraic inputs results in algebra being passed to a\r\n                    Register. Algebraic Simulation has not been implemented for this component."]), comp.FullName, singleton(comp.cId), empty()));
            }
            break;
        }
        case 37: {
            const matchValue_124 = item(simStepOld, item(0, comp.InputLinks).FDataStep);
            const matchValue_125 = item(simStepOld, item(1, comp.InputLinks).FDataStep);
            let matchResult_18, bits_25, enable;
            if (matchValue_124.tag === 0) {
                if (matchValue_125.tag === 0) {
                    matchResult_18 = 0;
                    bits_25 = matchValue_124.fields[0];
                    enable = matchValue_125.fields[0];
                }
                else {
                    matchResult_18 = 1;
                }
            }
            else {
                matchResult_18 = 1;
            }
            switch (matchResult_18) {
                case 0: {
                    if (((fd__13 = (new FData(/* Data */ 0, [enable])), (fd__13.tag === 0) ? ((fd_181 = fd__13.fields[0], (matchValue_127 = fd_181.Dat, (matchValue_127.tag === 1) ? toFail(`Can't extract ${interpolate("%d%P()", [1])} bit from BigWord data ${fd_181.Dat} of width ${fd_181.Width}`) : matchValue_127.fields[0]))) : toFail(printf("Can\'t extract data from Algebra")))) === 1) {
                        item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Data */ 0, [bits_25]));
                    }
                    else {
                        let fd_183;
                        const matchValue_128 = item(0, comp.Outputs).Width | 0;
                        fd_183 = ((matchValue_128 === 0) ? toFail(printf("Can\'t reduce %A (%A) because outputwidth is not known"))(comp.FullName)(comp.FType) : ((numStep === 0) ? (new FData(/* Data */ 0, [new FastData(new FastBits(/* Word */ 0, [0]), matchValue_128)])) : item(simStepOld, item(0, comp.Outputs).FDataStep)));
                        item(0, comp.Outputs).FDataStep[simStep] = fd_183;
                    }
                    break;
                }
                case 1: {
                    throw new AlgebraNotImplemented(new SimulationError(new SimulationErrorType(/* AlgInpNotAllowed */ 15, ["The chosen set of Algebraic inputs results in algebra being passed to a\r\n                    RegisterE. Algebraic Simulation has not been implemented for this component."]), comp.FullName, singleton(comp.cId), empty()));
                    break;
                }
            }
            break;
        }
        case 38: {
            const matchValue_130 = item(simStepOld, item(0, comp.InputLinks).FDataStep);
            const matchValue_131 = item(simStepOld, item(1, comp.InputLinks).FDataStep);
            const matchValue_132 = item(simStepOld, item(2, comp.InputLinks).FDataStep);
            let matchResult_19, bits_26, enable_1, load;
            if (matchValue_130.tag === 0) {
                if (matchValue_131.tag === 0) {
                    if (matchValue_132.tag === 0) {
                        matchResult_19 = 0;
                        bits_26 = matchValue_130.fields[0];
                        enable_1 = matchValue_132.fields[0];
                        load = matchValue_131.fields[0];
                    }
                    else {
                        matchResult_19 = 1;
                    }
                }
                else {
                    matchResult_19 = 1;
                }
            }
            else {
                matchResult_19 = 1;
            }
            switch (matchResult_19) {
                case 0: {
                    if ((((fd__14 = (new FData(/* Data */ 0, [enable_1])), (fd__14.tag === 0) ? ((fd_188 = fd__14.fields[0], (matchValue_134 = fd_188.Dat, (matchValue_134.tag === 1) ? toFail(`Can't extract ${interpolate("%d%P()", [1])} bit from BigWord data ${fd_188.Dat} of width ${fd_188.Width}`) : matchValue_134.fields[0]))) : toFail(printf("Can\'t extract data from Algebra")))) === 1) && (((fd__15 = (new FData(/* Data */ 0, [load])), (fd__15.tag === 0) ? ((fd_189 = fd__15.fields[0], (matchValue_135 = fd_189.Dat, (matchValue_135.tag === 1) ? toFail(`Can't extract ${interpolate("%d%P()", [1])} bit from BigWord data ${fd_189.Dat} of width ${fd_189.Width}`) : matchValue_135.fields[0]))) : toFail(printf("Can\'t extract data from Algebra")))) === 0)) {
                        let res_2;
                        const width_17 = bits_26.Width | 0;
                        const masked = op_BitwiseAnd(op_Addition((matchValue_138 = FData__get_toFastData((matchValue_136 = (item(0, comp.Outputs).Width | 0), (matchValue_136 === 0) ? toFail(printf("Can\'t reduce %A (%A) because outputwidth is not known"))(comp.FullName)(comp.FType) : ((numStep === 0) ? (new FData(/* Data */ 0, [new FastData(new FastBits(/* Word */ 0, [0]), matchValue_136)])) : item(simStepOld, item(0, comp.Outputs).FDataStep)))).Dat, (matchValue_138.tag === 1) ? matchValue_138.fields[0] : fromUInt32(matchValue_138.fields[0])), fromOne()), op_Subtraction(op_LeftShift(fromOne(), width_17), fromOne()));
                        res_2 = ((width_17 <= 32) ? (new FastData(new FastBits(/* Word */ 0, [toUInt32(masked) >>> 0]), width_17)) : (new FastData(new FastBits(/* BigWord */ 1, [masked]), width_17)));
                        item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Data */ 0, [res_2]));
                    }
                    else if ((((fd__16 = (new FData(/* Data */ 0, [enable_1])), (fd__16.tag === 0) ? ((fd_192 = fd__16.fields[0], (matchValue_139 = fd_192.Dat, (matchValue_139.tag === 1) ? toFail(`Can't extract ${interpolate("%d%P()", [1])} bit from BigWord data ${fd_192.Dat} of width ${fd_192.Width}`) : matchValue_139.fields[0]))) : toFail(printf("Can\'t extract data from Algebra")))) === 1) && (((fd__17 = (new FData(/* Data */ 0, [load])), (fd__17.tag === 0) ? ((fd_193 = fd__17.fields[0], (matchValue_140 = fd_193.Dat, (matchValue_140.tag === 1) ? toFail(`Can't extract ${interpolate("%d%P()", [1])} bit from BigWord data ${fd_193.Dat} of width ${fd_193.Width}`) : matchValue_140.fields[0]))) : toFail(printf("Can\'t extract data from Algebra")))) === 1)) {
                        item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Data */ 0, [bits_26]));
                    }
                    else {
                        let fd_195;
                        const matchValue_141 = item(0, comp.Outputs).Width | 0;
                        fd_195 = ((matchValue_141 === 0) ? toFail(printf("Can\'t reduce %A (%A) because outputwidth is not known"))(comp.FullName)(comp.FType) : ((numStep === 0) ? (new FData(/* Data */ 0, [new FastData(new FastBits(/* Word */ 0, [0]), matchValue_141)])) : item(simStepOld, item(0, comp.Outputs).FDataStep)));
                        item(0, comp.Outputs).FDataStep[simStep] = fd_195;
                    }
                    break;
                }
                case 1: {
                    throw new AlgebraNotImplemented(new SimulationError(new SimulationErrorType(/* AlgInpNotAllowed */ 15, ["The chosen set of Algebraic inputs results in algebra being passed to a\r\n                    Counter. Algebraic Simulation has not been implemented for this component."]), comp.FullName, singleton(comp.cId), empty()));
                    break;
                }
            }
            break;
        }
        case 39: {
            const matchValue_143 = item(simStepOld, item(0, comp.InputLinks).FDataStep);
            const matchValue_144 = item(simStepOld, item(1, comp.InputLinks).FDataStep);
            let matchResult_20, bits_27, load_1;
            if (matchValue_143.tag === 0) {
                if (matchValue_144.tag === 0) {
                    matchResult_20 = 0;
                    bits_27 = matchValue_143.fields[0];
                    load_1 = matchValue_144.fields[0];
                }
                else {
                    matchResult_20 = 1;
                }
            }
            else {
                matchResult_20 = 1;
            }
            switch (matchResult_20) {
                case 0: {
                    if (((fd__18 = (new FData(/* Data */ 0, [load_1])), (fd__18.tag === 0) ? ((fd_199 = fd__18.fields[0], (matchValue_146 = fd_199.Dat, (matchValue_146.tag === 1) ? toFail(`Can't extract ${interpolate("%d%P()", [1])} bit from BigWord data ${fd_199.Dat} of width ${fd_199.Width}`) : matchValue_146.fields[0]))) : toFail(printf("Can\'t extract data from Algebra")))) === 0) {
                        let res_3;
                        const width_20 = bits_27.Width | 0;
                        const masked_1 = op_BitwiseAnd(op_Addition((matchValue_149 = FData__get_toFastData((matchValue_147 = (item(0, comp.Outputs).Width | 0), (matchValue_147 === 0) ? toFail(printf("Can\'t reduce %A (%A) because outputwidth is not known"))(comp.FullName)(comp.FType) : ((numStep === 0) ? (new FData(/* Data */ 0, [new FastData(new FastBits(/* Word */ 0, [0]), matchValue_147)])) : item(simStepOld, item(0, comp.Outputs).FDataStep)))).Dat, (matchValue_149.tag === 1) ? matchValue_149.fields[0] : fromUInt32(matchValue_149.fields[0])), fromOne()), op_Subtraction(op_LeftShift(fromOne(), width_20), fromOne()));
                        res_3 = ((width_20 <= 32) ? (new FastData(new FastBits(/* Word */ 0, [toUInt32(masked_1) >>> 0]), width_20)) : (new FastData(new FastBits(/* BigWord */ 1, [masked_1]), width_20)));
                        item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Data */ 0, [res_3]));
                    }
                    else {
                        item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Data */ 0, [bits_27]));
                    }
                    break;
                }
                case 1: {
                    throw new AlgebraNotImplemented(new SimulationError(new SimulationErrorType(/* AlgInpNotAllowed */ 15, ["The chosen set of Algebraic inputs results in algebra being passed to a\r\n                    Counter. Algebraic Simulation has not been implemented for this component."]), comp.FullName, singleton(comp.cId), empty()));
                    break;
                }
            }
            break;
        }
        case 40: {
            const width_21 = componentType.fields[0] | 0;
            const matchValue_150 = item(simStepOld, item(0, comp.InputLinks).FDataStep);
            if (matchValue_150.tag === 0) {
                if (((fd__19 = (new FData(/* Data */ 0, [matchValue_150.fields[0]])), (fd__19.tag === 0) ? ((fd_204 = fd__19.fields[0], (matchValue_151 = fd_204.Dat, (matchValue_151.tag === 1) ? toFail(`Can't extract ${interpolate("%d%P()", [1])} bit from BigWord data ${fd_204.Dat} of width ${fd_204.Width}`) : matchValue_151.fields[0]))) : toFail(printf("Can\'t extract data from Algebra")))) === 1) {
                    const n_166 = op_Addition((matchValue_154 = FData__get_toFastData((matchValue_152 = (item(0, comp.Outputs).Width | 0), (matchValue_152 === 0) ? toFail(printf("Can\'t reduce %A (%A) because outputwidth is not known"))(comp.FullName)(comp.FType) : ((numStep === 0) ? (new FData(/* Data */ 0, [new FastData(new FastBits(/* Word */ 0, [0]), matchValue_152)])) : item(simStepOld, item(0, comp.Outputs).FDataStep)))).Dat, (matchValue_154.tag === 1) ? matchValue_154.fields[0] : fromUInt32(matchValue_154.fields[0])), fromOne());
                    let res_4;
                    const width_23 = width_21 | 0;
                    const masked_2 = op_BitwiseAnd(equals(n_166, op_LeftShift(fromOne(), width_21)) ? fromZero() : n_166, op_Subtraction(op_LeftShift(fromOne(), width_23), fromOne()));
                    res_4 = ((width_23 <= 32) ? (new FastData(new FastBits(/* Word */ 0, [toUInt32(masked_2) >>> 0]), width_23)) : (new FastData(new FastBits(/* BigWord */ 1, [masked_2]), width_23)));
                    item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Data */ 0, [res_4]));
                }
                else {
                    let fd_207;
                    const matchValue_155 = item(0, comp.Outputs).Width | 0;
                    fd_207 = ((matchValue_155 === 0) ? toFail(printf("Can\'t reduce %A (%A) because outputwidth is not known"))(comp.FullName)(comp.FType) : ((numStep === 0) ? (new FData(/* Data */ 0, [new FastData(new FastBits(/* Word */ 0, [0]), matchValue_155)])) : item(simStepOld, item(0, comp.Outputs).FDataStep)));
                    item(0, comp.Outputs).FDataStep[simStep] = fd_207;
                }
            }
            else {
                throw new AlgebraNotImplemented(new SimulationError(new SimulationErrorType(/* AlgInpNotAllowed */ 15, ["The chosen set of Algebraic inputs results in algebra being passed to a\r\n                    Counter. Algebraic Simulation has not been implemented for this component."]), comp.FullName, singleton(comp.cId), empty()));
            }
            break;
        }
        case 41: {
            const width_24 = componentType.fields[0] | 0;
            const n_174 = op_Addition((matchValue_159 = FData__get_toFastData((matchValue_157 = (item(0, comp.Outputs).Width | 0), (matchValue_157 === 0) ? toFail(printf("Can\'t reduce %A (%A) because outputwidth is not known"))(comp.FullName)(comp.FType) : ((numStep === 0) ? (new FData(/* Data */ 0, [new FastData(new FastBits(/* Word */ 0, [0]), matchValue_157)])) : item(simStepOld, item(0, comp.Outputs).FDataStep)))).Dat, (matchValue_159.tag === 1) ? matchValue_159.fields[0] : fromUInt32(matchValue_159.fields[0])), fromOne());
            let res_5;
            const width_26 = width_24 | 0;
            const masked_3 = op_BitwiseAnd(equals(n_174, op_LeftShift(fromOne(), width_24)) ? fromZero() : n_174, op_Subtraction(op_LeftShift(fromOne(), width_26), fromOne()));
            res_5 = ((width_26 <= 32) ? (new FastData(new FastBits(/* Word */ 0, [toUInt32(masked_3) >>> 0]), width_26)) : (new FastData(new FastBits(/* BigWord */ 1, [masked_3]), width_26)));
            item(0, comp.Outputs).FDataStep[simStep] = (new FData(/* Data */ 0, [res_5]));
            break;
        }
        case 42: {
            const fd_212 = item(simStep, item(0, comp.InputLinks).FDataStep);
            if (fd_212.tag === 0) {
                const fd_213 = readMemoryFData(componentType.fields[0], new FData(/* Data */ 0, [fd_212.fields[0]]));
                item(0, comp.Outputs).FDataStep[simStep] = fd_213;
            }
            else {
                throw new AlgebraNotImplemented(new SimulationError(new SimulationErrorType(/* AlgInpNotAllowed */ 15, ["The chosen set of Algebraic inputs results in algebra being passed to\r\n                    AsyncRom. Algebraic Simulation has not been implemented for this component."]), comp.FullName, singleton(comp.cId), empty()));
            }
            break;
        }
        case 43: {
            const fd_215 = item(simStepOld, item(0, comp.InputLinks).FDataStep);
            if (fd_215.tag === 0) {
                const fd_216 = readMemoryFData(componentType.fields[0], new FData(/* Data */ 0, [fd_215.fields[0]]));
                item(0, comp.Outputs).FDataStep[simStep] = fd_216;
            }
            else {
                throw new AlgebraNotImplemented(new SimulationError(new SimulationErrorType(/* AlgInpNotAllowed */ 15, ["The chosen set of Algebraic inputs results in algebra being passed to\r\n                    ROM. Algebraic Simulation has not been implemented for this component."]), comp.FullName, singleton(comp.cId), empty()));
            }
            break;
        }
        case 44: {
            let memState;
            if (numStep === 0) {
                const state_4 = getRamState(simStep, comp.State);
                reset(ramStoreOf(state_4));
                memState = state_4;
            }
            else {
                memState = getRamState(simStepOld, comp.State);
            }
            const mem_2 = ramStoreOf(memState);
            const matchValue_160 = item(simStepOld, item(0, comp.InputLinks).FDataStep);
            const matchValue_161 = item(simStepOld, item(1, comp.InputLinks).FDataStep);
            let matchResult_21, address, dataIn;
            if (matchValue_160.tag === 0) {
                if (matchValue_161.tag === 0) {
                    matchResult_21 = 0;
                    address = matchValue_160.fields[0];
                    dataIn = matchValue_161.fields[0];
                }
                else {
                    matchResult_21 = 1;
                }
            }
            else {
                matchResult_21 = 1;
            }
            switch (matchResult_21) {
                case 0: {
                    let write;
                    const fd__20 = item(simStepOld, item(2, comp.InputLinks).FDataStep);
                    if (fd__20.tag === 0) {
                        const fd_220 = fd__20.fields[0];
                        const matchValue_163 = fd_220.Dat;
                        write = ((matchValue_163.tag === 1) ? toFail(`Can't extract ${interpolate("%d%P()", [1])} bit from BigWord data ${fd_220.Dat} of width ${fd_220.Width}`) : matchValue_163.fields[0]);
                    }
                    else {
                        write = toFail(printf("Can\'t extract data from Algebra"));
                    }
                    const dataOut = (numStep === 0) ? (new FData(/* Data */ 0, [convertIntToFastData(mem_2.WordWidth, 0)])) : readRamFData(mem_2, new FData(/* Data */ 0, [address]));
                    switch (write) {
                        case 0: {
                            break;
                        }
                        case 1: {
                            writeRamFData(mem_2, numStep, address, dataIn);
                            break;
                        }
                        default:
                            toFail(`simulation error: invalid 1 bit write value ${write}`);
                    }
                    const matchValue_164 = comp.State;
                    if (matchValue_164 != null) {
                        const stateArr = matchValue_164;
                        stateArr.Step[simStep] = memState;
                    }
                    else {
                        toFail(printf("Attempt to put state into component %s without state array"))(comp.FullName);
                    }
                    item(0, comp.Outputs).FDataStep[simStep] = dataOut;
                    break;
                }
                case 1: {
                    throw new AlgebraNotImplemented(new SimulationError(new SimulationErrorType(/* AlgInpNotAllowed */ 15, ["The chosen set of Algebraic inputs results in algebra being passed to\r\n                    RAM. Algebraic Simulation has not been implemented for this component."]), comp.FullName, singleton(comp.cId), empty()));
                    break;
                }
            }
            break;
        }
        case 45: {
            const err_19 = new SimulationError(new SimulationErrorType(/* AlgInpNotAllowed */ 15, ["The chosen set of Algebraic inputs results in algebra being passed to\r\n                    AsyncRam. Algebraic Simulation has not been implemented for this component."]), comp.FullName, singleton(comp.cId), empty());
            if (isClockedReduction) {
                let memState_1;
                if (numStep === 0) {
                    const state_6 = getRamState(simStep, comp.State);
                    reset(ramStoreOf(state_6));
                    memState_1 = state_6;
                }
                else {
                    memState_1 = getRamState(simStepOld, comp.State);
                }
                const mem_3 = ramStoreOf(memState_1);
                let address_1;
                const matchValue_165 = item(simStepOld, item(0, comp.InputLinks).FDataStep);
                if (matchValue_165.tag === 1) {
                    throw new AlgebraNotImplemented(err_19);
                }
                else {
                    address_1 = matchValue_165.fields[0];
                }
                let dataIn_1;
                const matchValue_166 = item(simStepOld, item(1, comp.InputLinks).FDataStep);
                if (matchValue_166.tag === 1) {
                    throw new AlgebraNotImplemented(err_19);
                }
                else {
                    dataIn_1 = matchValue_166.fields[0];
                }
                const matchValue_167 = item(simStepOld, item(2, comp.InputLinks).FDataStep);
                if (matchValue_167.tag === 1) {
                    throw new AlgebraNotImplemented(err_19);
                }
                else {
                    matchValue_167.fields[0];
                }
                let write_1;
                const fd__21 = item(simStepOld, item(2, comp.InputLinks).FDataStep);
                if (fd__21.tag === 0) {
                    const fd_226 = fd__21.fields[0];
                    const matchValue_168 = fd_226.Dat;
                    write_1 = ((matchValue_168.tag === 1) ? toFail(`Can't extract ${interpolate("%d%P()", [1])} bit from BigWord data ${fd_226.Dat} of width ${fd_226.Width}`) : matchValue_168.fields[0]);
                }
                else {
                    write_1 = toFail(printf("Can\'t extract data from Algebra"));
                }
                switch (write_1) {
                    case 0: {
                        break;
                    }
                    case 1: {
                        writeRamFData(mem_3, numStep, address_1, dataIn_1);
                        break;
                    }
                    default:
                        toFail(`simulation error: invalid 1 bit write value ${write_1}`);
                }
                const matchValue_169 = comp.State;
                if (matchValue_169 != null) {
                    const stateArr_1 = matchValue_169;
                    stateArr_1.Step[simStep] = memState_1;
                }
                else {
                    toFail(printf("Attempt to put state into component %s without state array"))(comp.FullName);
                }
            }
            else {
                const fd_228 = readRamFData(getRamStore(simStep, comp.State), new FData(/* Data */ 0, [(matchValue_170 = item(simStep, item(0, comp.InputLinks).FDataStep), (matchValue_170.tag === 1) ? (() => {
                    throw new AlgebraNotImplemented(err_19);
                })() : matchValue_170.fields[0])]));
                item(0, comp.Outputs).FDataStep[simStep] = fd_228;
            }
            break;
        }
        case 46: {
            toFail(`simulation error: deprecated component type ${componentType}`);
            break;
        }
    }
}

